(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[539],{

/***/ 13561:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/[hash]/[slug]",
      function () {
        return __webpack_require__(36708);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ StyledDialog; },
/* harmony export */   "V": function() { return /* binding */ Dialog; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);
/* harmony import */ var _material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52663);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74815);



function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  .MuiDialog-paperScrollPaper > div {\n    margin-bottom: 0;\n    box-shadow: none;\n  }\n\n  @media (max-width: 640px) {\n    .MuiDialog-paper {\n      margin: 0;\n      width: 100%;\n      height: 100%;\n      max-width: none;\n      max-height: none;\n      border-radius: 0;\n      box-shadow: none;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 2rem;\n  width: 600px;\n  min-height: 200px;\n  max-height: 100%;\n  border-radius: ",
        "px;\n  background-color: ",
        ";\n\n  box-sizing: border-box;\n\n  @media (max-width: 640px) {\n    width: 100%;\n    height: 100%;\n    border-radius: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var StyledDialog = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-64768589-0"
})(_templateObject());
var Dialog = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-64768589-1"
})(_templateObject1(), _Theme__WEBPACK_IMPORTED_MODULE_0__/* .borderRadius */ .E0, _Theme__WEBPACK_IMPORTED_MODULE_0__/* .Color.white */ .Il.white);


/***/ }),

/***/ 81628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useCompanyDictionary; }
/* harmony export */ });
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86896);

/** Translations for all company field names */ var useCompanyDictionary = function() {
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    var dictionary = {
        companyID: '',
        name: intl.formatMessage({
            id: 'company.name',
            defaultMessage: 'Toiminimi'
        }),
        marketingName: intl.formatMessage({
            id: 'company.marketingName',
            defaultMessage: 'Markkinointinimi'
        }),
        businessID: '',
        description: intl.formatMessage({
            id: 'company.description',
            defaultMessage: 'Yritysesittely'
        }),
        dateEstablished: intl.formatMessage({
            id: 'company.dateEstablished',
            defaultMessage: 'Perustamisvuosi'
        }),
        timeCreate: '',
        phone: intl.formatMessage({
            id: 'company.phone',
            defaultMessage: 'Puhelinnumero'
        }),
        fax: intl.formatMessage({
            id: 'company.fax',
            defaultMessage: 'Faksi'
        }),
        email: intl.formatMessage({
            id: 'company.email',
            defaultMessage: 'S\xe4hk\xf6postiosoite'
        }),
        homepage: intl.formatMessage({
            id: 'company.homepage',
            defaultMessage: 'Kotisivu'
        }),
        numberOfEmployees: intl.formatMessage({
            id: 'company.numberOfEmployees',
            defaultMessage: 'Henkil\xf6st\xf6m\xe4\xe4r\xe4'
        }),
        turnover: intl.formatMessage({
            id: 'company.turnover',
            defaultMessage: 'Liikevaihto'
        }),
        postalAddress: intl.formatMessage({
            id: 'company.postalAddress',
            defaultMessage: 'Postiosoite'
        }),
        visitingAddress: intl.formatMessage({
            id: 'company.visitingAddress',
            defaultMessage: 'Vierailuosoite'
        }),
        tol: intl.formatMessage({
            id: 'company.tol',
            defaultMessage: 'P\xe4\xe4toimiala (TOL2008)'
        }),
        businessType: '',
        domicile: intl.formatMessage({
            id: 'company.domicile',
            defaultMessage: 'Kotipaikka'
        }),
        projectTypes: intl.formatMessage({
            id: 'company.projectTypes',
            defaultMessage: 'Hanketyypit'
        }),
        contractingForms: intl.formatMessage({
            id: 'company.contractingForms',
            defaultMessage: 'Urakointimuodot'
        }),
        customerTargetGroups: intl.formatMessage({
            id: 'company.customerTargetGroups',
            defaultMessage: 'Asiakaskohderyhm\xe4t'
        }),
        machineryTypes: intl.formatMessage({
            id: 'company.machineryTypes',
            defaultMessage: 'Konekanta'
        }),
        taitoCompetences: intl.formatMessage({
            id: 'company.taitoCompetences',
            defaultMessage: 'Taitorekisteri'
        }),
        languages: intl.formatMessage({
            id: 'company.languages',
            defaultMessage: 'Ty\xf6maakielet'
        }),
        talo80: intl.formatMessage({
            id: 'company.talo80',
            defaultMessage: 'Toimialaluokat'
        }),
        operationalAreas: intl.formatMessage({
            id: 'company.operationalAreas',
            defaultMessage: 'Toimialueet'
        }),
        locations: intl.formatMessage({
            id: 'company.locations',
            defaultMessage: 'Toimipisteet'
        }),
        contactPersons: intl.formatMessage({
            id: 'company.contactPersons',
            defaultMessage: 'Yhteyshenkil\xf6t'
        }),
        // @ts-ignore
        sales: intl.formatMessage({
            id: 'company.sales',
            defaultMessage: 'Myynti'
        }),
        references: intl.formatMessage({
            id: 'company.references',
            defaultMessage: 'Referenssit'
        }),
        referencesDescription: intl.formatMessage({
            id: 'company.references.description',
            defaultMessage: 'Kuvaus'
        }),
        referencesValue: intl.formatMessage({
            id: 'company.references.value',
            defaultMessage: 'Urakan arvo'
        }),
        referencesDate: intl.formatMessage({
            id: 'company.references.date',
            defaultMessage: 'Ajankohta'
        }),
        referencesCustomer: intl.formatMessage({
            id: 'company.references.customer',
            defaultMessage: 'Tilaaja'
        })
    };
    return dictionary;
};


/***/ }),

/***/ 2971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ar": function() { return /* binding */ StyledLabel; },
/* harmony export */   "gN": function() { return /* binding */ Field; },
/* harmony export */   "Od": function() { return /* binding */ Skeleton; },
/* harmony export */   "pu": function() { return /* binding */ Quote; },
/* harmony export */   "Af": function() { return /* binding */ Chip; }
/* harmony export */ });
/* unused harmony export SkeletonChip */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44012);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87379);
/* harmony import */ var _material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58365);
/* harmony import */ var _PremiumIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16742);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74815);







function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: ",
        ";\n  opacity: 0.8;\n\n  > .premium-icon {\n    margin-left: 0.2rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  .value {\n    display: ",
        ";\n    align-items: center;\n    line-height: ",
        "rem;\n    margin-top: 0.3rem;\n    font-size: ",
        "rem;\n    font-weight: ",
        ";\n\n    svg:first-child {\n      margin-right: 0.4rem;\n      margin-bottom: -1px;\n    }\n\n    span {\n      margin-right: 0.4rem;\n    }\n  }\n\n  .empty {\n    line-height: ",
        "rem;\n    font-size: 1rem;\n    font-weight: normal;\n    opacity: 0.4;\n  }\n\n  a {\n    display: inline-flex;\n    align-items: center;\n\n    /* NOTE! This should probably be in the main stylesheet, or is it an exception? */\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  &:before,\n  &:after {\n    display: inline-block;\n    opacity: 0.4;\n  }\n  &:before {\n    margin-right: 0.1rem;\n    content: '“';\n  }\n  &:after {\n    margin-left: 0.1rem;\n    content: '”';\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        ";\n  display: inline-block;\n  position: relative;\n  margin-top: 0.4rem;\n  margin-right: 0.4rem;\n  padding: 0.3rem 0.6rem;\n  background-color: ",
        ";\n  color: ",
        ";\n  border-radius: 3px;\n\n  .skeleton {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    height: auto;\n    border-radius: 3px;\n    background: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var StyledLabel = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-db049034-0"
})(_templateObject(), _Theme__WEBPACK_IMPORTED_MODULE_3__/* .Color.black */ .Il.black);
var StyledField = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-db049034-1"
})(_templateObject1(), function(param) {
    var chip = param.chip;
    return chip ? 'block' : 'flex';
}, function(param) {
    var large = param.large;
    return large ? 1.9 : 1.4;
}, function(param) {
    var large = param.large;
    return large ? 1.5 : 1;
}, function(param) {
    var large = param.large;
    return large ? 500 : 400;
}, function(param) {
    var large = param.large;
    return large ? 1.9 : 1.4;
}, _Theme__WEBPACK_IMPORTED_MODULE_3__/* .Color.primary */ .Il.primary);
/** Company field with label and value */ var Field = function(param) {
    var label = param.label, premiumOnly = param.premiumOnly, large = param.large, loading = param.loading, empty = param.empty, _chip = param.chip, chip = _chip === void 0 ? false : _chip, _premium = param.premium, premium = _premium === void 0 ? false : _premium, children = param.children;
    var isLoading = loading;
    var isPremium = premium;
    var content = children;
    if (isLoading && premiumOnly) {
        // If is loading an is premium only, render a loading indicator
        content = chip ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SkeletonChip, {
                    loading: true,
                    width: "20%"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SkeletonChip, {
                    loading: true,
                    width: "28%"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SkeletonChip, {
                    loading: true,
                    width: "18%"
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Skeleton, {
            width: "30%",
            loading: true
        });
    } else if (premiumOnly && empty && !isPremium) {
        // If field is premium only, but the user is not premium, render gray box
        content = chip ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SkeletonChip, {
                    width: "20%"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SkeletonChip, {
                    width: "28%"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SkeletonChip, {
                    width: "18%"
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Skeleton, {
            width: "30%"
        });
    } else if (empty) {
        // If field is marked as "empty", render the "not available" state
        content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
            className: "empty",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                id: "company.emptyField",
                defaultMessage: "Ei saatavilla"
            })
        });
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledField, {
        large: large,
        chip: chip,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledLabel, {
                className: "label",
                children: [
                    label,
                    " ",
                    premiumOnly && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PremiumIcon__WEBPACK_IMPORTED_MODULE_2__/* .PremiumIcon */ .T, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "value",
                children: content
            })
        ]
    }));
};
/** Show skeleton value
 *  Use to show skeleton value
 * */ var Skeleton = function(param) {
    var _width = param.width, width = _width === void 0 ? 'auto' : _width, _height = param.height, height = _height === void 0 ? 'auto' : _height, _loading = param.loading, loading = _loading === void 0 ? false : _loading;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        animation: loading ? 'wave' : false,
        width: width,
        height: height
    });
};
/** Wrap field value in quotes */ var Quote = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-db049034-2"
})(_templateObject2());
/** Render info chip */ var Chip = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-db049034-3"
})(_templateObject3(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var selected = param.selected;
    return selected ? _Theme__WEBPACK_IMPORTED_MODULE_3__/* .Color.primary */ .Il.primary : 'rgb(224, 224, 224)';
}, function(param) {
    var selected = param.selected;
    return selected ? _Theme__WEBPACK_IMPORTED_MODULE_3__/* .Color.white */ .Il.white : _Theme__WEBPACK_IMPORTED_MODULE_3__/* .Color.black */ .Il.black;
});
/** Render skeleton info chip
 *  Implemented as MUI Skeleton rendered inside a normal chip to get exact same dimensions
 * */ var SkeletonChip = function(param) {
    var _width = param.width, width = _width === void 0 ? 'auto' : _width, _loading = param.loading, loading = _loading === void 0 ? false : _loading;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Chip, {
        width: width,
        children: [
            "\xa0",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: "skeleton",
                animation: loading ? 'wave' : false,
                variant: "rect"
            })
        ]
    });
};


/***/ }),

/***/ 66235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "rj": function() { return /* binding */ Grid; },
/* harmony export */   "sg": function() { return /* binding */ Column; },
/* harmony export */   "ck": function() { return /* binding */ Item; },
/* harmony export */   "LZ": function() { return /* binding */ Spacer; },
/* harmony export */   "KH": function() { return /* binding */ BasicInfoGrid; }
/* harmony export */ });
/* unused harmony exports ItemStyle, SpacerStyle */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74815);



function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    flex-direction: column;\n    padding: 1rem;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  padding: 2rem;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    &:not(:last-of-type) {\n      padding-right: 0;\n      border-right: none;\n    }\n\n    &:not(:first-of-type) {\n      padding-left: 0;\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1;\n\n  &:not(:last-of-type) {\n    padding-right: 1rem;\n    border-right: 2px solid ",
        ";\n  }\n\n  &:not(:first-of-type) {\n    padding-left: 1rem;\n  }\n\n  ",
        "\n\n  ",
        " {\n    padding: 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 1.2rem;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0.6rem 0;\n  height: 2px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n\n  > .MuiButton-root {\n    position: absolute;\n    top: 1.1rem;\n    right: 1rem;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
var Grid = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a143aefe-0"
})(_templateObject1(), _Theme__WEBPACK_IMPORTED_MODULE_1__/* .mediaQuery.small */ .cy.small((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject())));
var Column = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a143aefe-1"
})(_templateObject3(), _Theme__WEBPACK_IMPORTED_MODULE_1__/* .Color.background */ .Il.background, _Theme__WEBPACK_IMPORTED_MODULE_1__/* .mediaQuery.small */ .cy.small((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2())), Grid);
var ItemStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a143aefe-2"
})(_templateObject4());
var Item = function(param) {
    var _show = param.show, show = _show === void 0 ? true : _show, children = param.children;
    return !!show ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ItemStyle, {
        children: children
    }) : null;
};
var SpacerStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a143aefe-3"
})(_templateObject5(), _Theme__WEBPACK_IMPORTED_MODULE_1__/* .Color.background */ .Il.background);
var Spacer = function(param) {
    var _show = param.show, show = _show === void 0 ? true : _show, style = param.style;
    return !!show ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SpacerStyle, {
        style: style
    }) : null;
};
/** Has to be here, or the SSR won't work right... */ var BasicInfoGrid = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(Grid).withConfig({
    componentId: "sc-a143aefe-4"
})(_templateObject6());


/***/ }),

/***/ 6769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useCompanyActionMenuInSearch; },
/* harmony export */   "B": function() { return /* binding */ useCompanyActionMenuInPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _useCompanyActions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95804);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * An easy way to render company menu and recieve handler functions for it
 */ var useCompanyActionMenu = function(companyID, companyActions) {
    var ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _hideLikeDislike = ref.hideLikeDislike, hideLikeDislike = _hideLikeDislike === void 0 ? false : _hideLikeDislike;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), initial = ref1[0], setInitial = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), anchorEl = ref2[0], setAnchorEl = ref2[1];
    var isLiked = companyActions.isLiked, isDisliked = companyActions.isDisliked, listIDs = companyActions.listIDs;
    var handleMenuClose = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        return setAnchorEl(null);
    }, []);
    var handleMenuOpen = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(event) {
        return setAnchorEl(event.currentTarget);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        return setInitial(function(state) {
            return state || !!anchorEl;
        });
    }, [
        anchorEl
    ]);
    var isVisible = initial || !!anchorEl;
    // Import menu only if required
    var CompanyActionMenu1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return isVisible ? (0,next_dynamic__WEBPACK_IMPORTED_MODULE_1__["default"])(function() {
            return __webpack_require__.e(/* import() */ 3144).then(__webpack_require__.bind(__webpack_require__, 73144)).then(function(param) {
                var CompanyActionMenu = param.CompanyActionMenu;
                return CompanyActionMenu;
            });
        }, {
            loadableGenerated: {
                webpack: function() {
                    return [
                        /*require.resolve*/(73144)
                    ];
                }
            },
            loading: function() {
                return null;
            }
        }) : null;
    }, [
        isVisible
    ]);
    var renderMenu = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (!CompanyActionMenu1) return null;
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CompanyActionMenu1, _objectSpread({
            companyID: companyID,
            anchorEl: anchorEl,
            hideLikeDislike: hideLikeDislike,
            onClose: handleMenuClose
        }, companyActions)));
    }, [
        companyID,
        isLiked,
        isDisliked,
        listIDs,
        anchorEl,
        CompanyActionMenu1
    ]);
    return {
        handleMenuOpen: handleMenuOpen,
        handleMenuClose: handleMenuClose,
        renderMenu: renderMenu
    };
};
var useCompanyActionMenuInSearch = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        companyID: null,
        currentTarget: null
    }), menuState = ref[0], setMenuState = ref[1];
    var companyID1 = menuState.companyID, currentTarget = menuState.currentTarget;
    var companyActions = (0,_useCompanyActions__WEBPACK_IMPORTED_MODULE_3__/* .useCompanyActionsInSearch */ .s)(companyID1);
    var _ref = useCompanyActionMenu(companyID1, companyActions), _handleMenuOpen = _ref.handleMenuOpen, companyActionMenu = _objectWithoutProperties(_ref, [
        "handleMenuOpen"
    ]);
    // We have to let companyID state update before opening the dialog, this does just that
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (currentTarget) {
            setMenuState(_objectSpread({}, menuState, {
                currentTarget: null
            }));
            _handleMenuOpen({
                currentTarget: currentTarget
            });
        }
    }, [
        currentTarget
    ]);
    var handleMenuOpen = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(companyID, event) {
        event.preventDefault();
        event.stopPropagation();
        setMenuState({
            companyID: companyID,
            currentTarget: event.currentTarget
        });
    }, [
        _handleMenuOpen
    ]);
    return _objectSpread({}, companyActionMenu, {
        handleMenuOpen: handleMenuOpen
    });
};
/**
 * Handle company menu in search page.
 * Updates the search result list and cache accordingly.
 */ 
/**
 * Handle company menu in company page.
 * Updates the company data accordingly.
 */ var useCompanyActionMenuInPage = function(company) {
    var companyActions = (0,_useCompanyActions__WEBPACK_IMPORTED_MODULE_3__/* .useCompanyActionsInPage */ .u)(company);
    return useCompanyActionMenu(company.companyID, companyActions, {
        hideLikeDislike: true
    });
};


/***/ }),

/***/ 72685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ PremiumBannerStyle; },
/* harmony export */   "p": function() { return /* binding */ OmnibarPremiumBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87379);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83852);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22318);
/* harmony import */ var mdi_react_DiamondIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87452);
/* harmony import */ var mdi_react_DiamondIcon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(mdi_react_DiamondIcon__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18969);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40570);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74815);








function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  padding: 3rem;\n  background: linear-gradient(172deg, ",
        " 0%, ",
        " 100%);\n\n  h2 {\n    color: ",
        ";\n\n    svg {\n      opacity: 0.6;\n    }\n  }\n\n  p {\n    margin-top: 1.3rem;\n    margin-bottom: 0;\n    opacity: 0.75;\n  }\n\n  > div:first-of-type {\n    max-width: 70%;\n  }\n\n  > div:last-of-type {\n    display: flex;\n    flex: 1;\n    align-items: center;\n    justify-content: flex-end;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var PremiumBannerStyle = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2f3d36ab-0"
})(_templateObject(), (0,polished__WEBPACK_IMPORTED_MODULE_6__/* .transparentize */ .DZ)(0.85, _Theme__WEBPACK_IMPORTED_MODULE_4__/* .Color.primary */ .Il.primary), (0,polished__WEBPACK_IMPORTED_MODULE_6__/* .transparentize */ .DZ)(0.6, _Theme__WEBPACK_IMPORTED_MODULE_4__/* .Color.primary */ .Il.primary), _Theme__WEBPACK_IMPORTED_MODULE_4__/* .Color.primary */ .Il.primary);
var OmnibarPremiumBanner = function(param) {
    var title = param.title, description = param.description, _style = param.style, style = _style === void 0 ? {} : _style;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(PremiumBannerStyle, {
        style: style,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Header__WEBPACK_IMPORTED_MODULE_2__/* .Header */ .h, {
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_DiamondIcon__WEBPACK_IMPORTED_MODULE_1___default()), {
                            color: _Theme__WEBPACK_IMPORTED_MODULE_4__/* .Color.primary */ .Il.primary
                        }),
                        children: title !== null && title !== void 0 ? title : 'Hakukriteerit vaativat Constle Pro -j\xe4senyyden'
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        variant: "body1",
                        component: "p",
                        children: description || 'Hakukriteerien k\xe4ytt\xf6 on osa Constle Pro -j\xe4senyytt\xe4. J\xe4senen\xe4 p\xe4\xe4set nauttimaan kaikista Constlen tuomista eduista. Liity j\xe4seneksi jo t\xe4n\xe4\xe4n!'
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                    href: "/premium",
                    children: "Lue lis\xe4\xe4"
                })
            })
        ]
    });
};


/***/ }),

/***/ 49219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ handleBasicErrors; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44012);



var handleBasicErrors = function(param) {
    var status = param.status, _catchAll = param.catchAll, catchAll = _catchAll === void 0 ? false : _catchAll;
    if (status === 'bad request') {
        return {
            status: status,
            error: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                id: "unknownError",
                defaultMessage: "Jokin meni vikaan, yrit\xe4 my\xf6hemmin uudelleen…"
            })
        };
    }
    if (status === 'rate limit') {
        return {
            status: status,
            error: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                id: "error.rateLimit",
                defaultMessage: "Tietokanta on erityisen kiireinen. Odota muutama minuutti ja yrit\xe4 uudelleen…"
            })
        };
    }
    if (catchAll) {
        if (status !== 'ok') {
            return {
                status: status,
                error: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    id: "unknownError",
                    defaultMessage: "Jokin meni vikaan, yrit\xe4 my\xf6hemmin uudelleen…"
                })
            };
        }
    }
    return false;
};


/***/ }),

/***/ 36297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useOnScreen; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var useOnScreen = function(ref) {
    var ref1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _rootMargin = ref1.rootMargin, rootMargin = _rootMargin === void 0 ? '0px' : _rootMargin, _onlyOnce = ref1.onlyOnce, onlyOnce = _onlyOnce === void 0 ? false : _onlyOnce;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isVisible = ref2[0], setIsVisible = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var currentElement = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!currentElement) return;
        var observer = new IntersectionObserver(function(param) {
            var _param = _slicedToArray(param, 1), entry = _param[0];
            setIsVisible(function(state) {
                return onlyOnce ? state || entry.isIntersecting : entry.isIntersecting;
            });
        }, {
            rootMargin: rootMargin
        });
        if (currentElement) {
            observer.observe(currentElement);
        }
        return function() {
            observer.unobserve(currentElement);
        };
    }, [
        rootMargin
    ]);
    return isVisible;
};


/***/ }),

/***/ 26299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ recordCompanyVisit; },
/* harmony export */   "d": function() { return /* binding */ loadCompanyHistory; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var COMPANY_HISTORY_KEY = 'companyHistory';
var recordCompanyVisit = function(company) {
    var companyID = company.companyID, flags = company.flags, name = company.name, marketingName = company.marketingName, businessID = company.businessID, logo = company.logo;
    var companyHistoryItem = {
        companyID: companyID,
        flags: flags,
        name: name,
        marketingName: marketingName,
        businessID: businessID,
        logo: logo,
        timeVisited: new Date()
    };
    var history = loadCompanyHistory();
    var existingItemIndex = history.findIndex(function(item) {
        return item.companyID === companyID;
    });
    if (existingItemIndex >= 0) {
        history[existingItemIndex] = companyHistoryItem;
    } else {
        history.push(companyHistoryItem);
    }
    history.sort(function(a, b) {
        return b.timeVisited.valueOf() - a.timeVisited.valueOf();
    });
    saveCompanyHistory(history.slice(0, 6));
};
var saveCompanyHistory = function(history) {
    localStorage.setItem(COMPANY_HISTORY_KEY, JSON.stringify(history));
};
var loadCompanyHistory = function() {
    var history = JSON.parse(localStorage.getItem(COMPANY_HISTORY_KEY) || '[]');
    return history.map(function(item) {
        return _objectSpread({}, item, {
            timeVisited: new Date(item.timeVisited)
        });
    });
};


/***/ }),

/***/ 36708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/error.js
var error = __webpack_require__(12918);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Skeleton/Skeleton.js
var Skeleton = __webpack_require__(58365);
// EXTERNAL MODULE: ./components/Theme.ts
var Theme = __webpack_require__(74815);
;// CONCATENATED MODULE: ./components/company/CompanySkeleton.tsx





function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  margin-top: 4rem;\n  left: 0;\n  right: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n\n  div {\n    flex: 1;\n    padding-left: 2rem;\n\n    span:first-child {\n      margin-top: -0.5rem;\n      margin-bottom: 0.5rem;\n      font-size: 2.8rem;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 2rem;\n  height: calc(100vh + 4rem);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-178ca4f4-0"
})(_templateObject(), Theme/* layoutStyles */.pG);
var Hero = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-178ca4f4-1"
})(_templateObject1());
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-178ca4f4-2"
})(_templateObject2());
var CompanySkeleton = function() {
    var intl = (0,useIntl/* default */.Z)();
    var loadingAriaLabel = intl.formatMessage({
        id: 'company.loadingAriaLabel',
        defaultMessage: 'Ladataan...'
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                role: "alert",
                "aria-busy": "true",
                "aria-label": loadingAriaLabel
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                "aria-hidden": true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                animation: "wave",
                                width: 96,
                                height: 96,
                                style: {
                                    transform: 'none',
                                    borderRadius: Theme/* borderRadius */.E0,
                                    margin: 0
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        animation: "wave",
                                        width: "40%"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        animation: "wave",
                                        width: "17%"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                className: "icon",
                                animation: "wave",
                                width: 48 * 3,
                                height: 48,
                                style: {
                                    transform: 'none',
                                    borderRadius: 48,
                                    margin: 0
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            animation: "wave",
                            width: "100%",
                            height: "100%",
                            style: {
                                transform: 'none',
                                borderRadius: Theme/* borderRadius */.E0,
                                margin: 0
                            }
                        })
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/mdi-react/AccountIcon.js
var AccountIcon = __webpack_require__(30354);
var AccountIcon_default = /*#__PURE__*/__webpack_require__.n(AccountIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/PhoneIcon.js
var PhoneIcon = __webpack_require__(87132);
var PhoneIcon_default = /*#__PURE__*/__webpack_require__.n(PhoneIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/EmailIcon.js
var EmailIcon = __webpack_require__(70548);
var EmailIcon_default = /*#__PURE__*/__webpack_require__.n(EmailIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/MapMarkerIcon.js
var MapMarkerIcon = __webpack_require__(50293);
var MapMarkerIcon_default = /*#__PURE__*/__webpack_require__.n(MapMarkerIcon);
// EXTERNAL MODULE: ./components/Header.tsx
var Header = __webpack_require__(18969);
// EXTERNAL MODULE: ./components/Banner.tsx
var Banner = __webpack_require__(25310);
// EXTERNAL MODULE: ./components/PremiumIcon.tsx
var PremiumIcon = __webpack_require__(16742);
// EXTERNAL MODULE: ./components/company/CompanyDictionary.tsx
var CompanyDictionary = __webpack_require__(81628);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/List/List.js
var List = __webpack_require__(62822);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js + 1 modules
var TextField = __webpack_require__(33426);
// EXTERNAL MODULE: ./node_modules/mdi-react/ArrowLeftIcon.js
var ArrowLeftIcon = __webpack_require__(525);
var ArrowLeftIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowLeftIcon);
// EXTERNAL MODULE: ./lib/state.ts
var state = __webpack_require__(54442);
// EXTERNAL MODULE: ./node_modules/zustand/index.js
var zustand = __webpack_require__(14894);
// EXTERNAL MODULE: ./node_modules/zustand/middleware.js
var middleware = __webpack_require__(14316);
// EXTERNAL MODULE: ./common-react/selectOptionLogic.ts + 1 modules
var selectOptionLogic = __webpack_require__(97951);
// EXTERNAL MODULE: ./node_modules/lodash/pick.js
var pick = __webpack_require__(78718);
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);
// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18446);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ./node_modules/lodash/isArray.js
var isArray = __webpack_require__(1469);
var isArray_default = /*#__PURE__*/__webpack_require__.n(isArray);
// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(89734);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
;// CONCATENATED MODULE: ./components/company/companyEditCommon.ts




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
/** Convert a company document into the same form as the payload to the edit function */ var convertCompanyDocumentToEditable = function(document) {
    return _objectSpread({}, document, {
        projectTypes: document.projectTypes.map(function(projectType) {
            return {
                id: projectType.projectTypeID
            };
        }),
        contractingForms: document.contractingForms.map(function(contractingForm) {
            return {
                id: contractingForm.contractingFormID
            };
        }),
        customerTargetGroups: document.customerTargetGroups.map(function(customerTargetGroup) {
            return {
                id: customerTargetGroup.targetGroupID
            };
        }),
        machineryTypes: document.machineryTypes.map(function(machineryType) {
            return {
                id: machineryType.machineryTypeID,
                count: machineryType.count,
                range: machineryType.range
            };
        }),
        taitoCompetences: document.taitoCompetences.map(function(taitoCompetence) {
            return {
                id: taitoCompetence.competenceTypeID,
                totalAmountRange: taitoCompetence.totalAmountRange
            };
        }),
        languages: document.languages.map(function(language) {
            return {
                id: language.languageID
            };
        }),
        talo80: document.talo80.map(function(talo80) {
            return {
                id: talo80.talo80ID
            };
        }),
        operationalAreas: document.operationalAreas.map(function(operationalArea) {
            return {
                id: operationalArea.areaID
            };
        })
    });
};
/** Compare company document field values */ var compareCompanyDocumentFields = function(a, b) {
    /** Sanitize field data before comparison, this is necessary if Hookstate is used */ var sa = JSON.parse(JSON.stringify(a));
    var sb = JSON.parse(JSON.stringify(b));
    if (isArray_default()(sa) && isArray_default()(sb)) {
        return isEqual_default()(sortBy_default()(sa), sortBy_default()(sb));
    } else {
        return isEqual_default()(sa, sb);
    }
};
/**
 * Compare values of two company edit documents and return all changed fields
 * @param a The company document to be compared
 * @param b The original document to compare against
 * @param section List of keys to be compared
 * @returns A document with all changed fields or false if nothing changed
 */ var compareCompanyDocuments = function(a, b) {
    var section = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var document = section ? pick_default()(a, section) : _objectSpread({}, a);
    var documentKeys = Object.keys(document);
    var changedDocument = {};
    var originalDocument = b;
    if (documentKeys.length) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = documentKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if (document.hasOwnProperty(key) && !compareCompanyDocumentFields(originalDocument[key], document[key])) {
                    /** A value has changed, mark it as changed */ changedDocument[key] = document[key];
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return Object.keys(changedDocument).length ? changedDocument : false;
};

// EXTERNAL MODULE: ./context/staticStore.ts
var staticStore = __webpack_require__(30803);
;// CONCATENATED MODULE: ./context/companyEditStore.ts






function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function companyEditStore_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function companyEditStore_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            companyEditStore_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var companyEditStateDefaults = {
    description: '',
    phone: '',
    fax: '',
    email: '',
    logo: {
        path: ''
    },
    homepage: '',
    numberOfEmployees: {
        min: null,
        max: null
    },
    postalAddress: {
        street1: '',
        street2: '',
        city: '',
        postalCode: ''
    },
    visitingAddress: {
        street1: '',
        street2: '',
        city: '',
        postalCode: ''
    },
    domicile: {
        cityID: 0,
        cityName: '',
        provinceID: 0,
        provinceName: '',
        countryID: 0,
        countryName: ''
    },
    projectTypes: {
        selected: [],
        count: 0
    },
    contractingForms: {
        selected: [],
        count: 0
    },
    customerTargetGroups: {
        selected: [],
        count: 0
    },
    machineryTypes: {
        selected: [],
        count: 0
    },
    taitoCompetences: {
        selected: [],
        count: 0
    },
    languages: {
        selected: [],
        count: 0
    },
    talo80: {
        selected: [],
        count: 0
    },
    operationalAreas: {
        selected: [],
        count: 0
    },
    contactPersons: [],
    locations: [],
    references: []
};
var doGetEditRequestPayload = function(set1, get) {
    return (function() {
        var _ref1 = _asyncToGenerator(runtime_default().mark(function _callee(param) {
            var company, _ref, set, doGetEditRequestPayload1, editState, companyEditPayload, originalDocument, changedFields;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        company = param.company;
                        _ref = get(), set = _ref.set, doGetEditRequestPayload1 = _ref.doGetEditRequestPayload, editState = _objectWithoutProperties(_ref, [
                            "set",
                            "doGetEditRequestPayload"
                        ]);
                        companyEditPayload = {
                            companyID: company.companyID
                        };
                        originalDocument = convertCompanyDocumentToEditable(company);
                        changedFields = compareCompanyDocuments(convertStateToEditable(editState), originalDocument);
                        if (changedFields) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: 'nothing changed'
                        });
                    case 7:
                        return _ctx.abrupt("return", {
                            status: 'ok',
                            payload: companyEditStore_objectSpread({}, companyEditPayload, changedFields)
                        });
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref1.apply(this, arguments);
        };
    })();
};
/** Convert the original company document & the current edit state to the payload of the edit API endpoint */ 
/** Used to store the entire edited company document */ var companyEditState = (0,zustand/* default */.Z)((0,middleware/* combine */.$e)(companyEditStateDefaults, function(set, get) {
    return {
        doGetEditRequestPayload: doGetEditRequestPayload(set, get),
        set: set
    };
}));
var convertEditableSelectToState = function(value, path) {
    var items = staticStore/* staticState.getState */.G.getState()[path];
    var selectedIDs = value.map(function(entry) {
        return entry.id;
    });
    return {
        selected: selectedIDs,
        count: (0,selectOptionLogic/* countSelectedFromIDs */.uK)(selectedIDs, items)
    };
};
var convertStateSelectToEditable = function(value, path) {
    var selectedIDs = value.selected;
    if (path === 'machineryTypes') {
        return selectedIDs.map(function(id) {
            return {
                id: parseInt(id),
                count: 1,
                range: null
            };
        });
    }
    if (path === 'taitoCompetences') {
        return selectedIDs.map(function(id) {
            return {
                id: parseInt(id),
                totalAmountRange: '1-10'
            };
        });
    }
    return selectedIDs.map(function(id) {
        return {
            id: parseInt(id)
        };
    });
};
/** Convert WWWCompanyEditDocument to local edit state */ var convertEditableToState = function(document) {
    var selectFields = {
        projectTypes: convertEditableSelectToState(document.projectTypes, 'projectTypes'),
        contractingForms: convertEditableSelectToState(document.contractingForms, 'contractingForms'),
        customerTargetGroups: convertEditableSelectToState(document.customerTargetGroups, 'targetGroups'),
        machineryTypes: convertEditableSelectToState(document.machineryTypes, 'machineryTypes'),
        taitoCompetences: convertEditableSelectToState(document.taitoCompetences, 'taitoCompetences'),
        languages: convertEditableSelectToState(document.languages, 'languages'),
        talo80: convertEditableSelectToState(document.talo80, 'talo80'),
        operationalAreas: convertEditableSelectToState(document.operationalAreas, 'operationalAreas')
    };
    var contactPersons = _toConsumableArray(document.contactPersons.map(function(item) {
        return companyEditStore_objectSpread({}, item);
    }));
    var locations = _toConsumableArray(document.locations.map(function(item) {
        return companyEditStore_objectSpread({}, item);
    }));
    var references = _toConsumableArray(document.references.map(function(item) {
        return companyEditStore_objectSpread({}, item);
    }));
    return companyEditStore_objectSpread({}, document, selectFields, {
        contactPersons: contactPersons,
        locations: locations,
        references: references
    });
};
/** Convert local edit state to WWWCompanyEditDocument */ var convertStateToEditable = function(document) {
    var selectFields = {
        projectTypes: convertStateSelectToEditable(document.projectTypes, 'projectTypes'),
        contractingForms: convertStateSelectToEditable(document.contractingForms, 'contractingForms'),
        customerTargetGroups: convertStateSelectToEditable(document.customerTargetGroups, 'targetGroups'),
        machineryTypes: convertStateSelectToEditable(document.machineryTypes, 'machineryTypes'),
        taitoCompetences: convertStateSelectToEditable(document.taitoCompetences, 'taitoCompetences'),
        languages: convertStateSelectToEditable(document.languages, 'languages'),
        talo80: convertStateSelectToEditable(document.talo80, 'talo80'),
        operationalAreas: convertStateSelectToEditable(document.operationalAreas, 'operationalAreas')
    };
    var contactPersons = _toConsumableArray(document.contactPersons.map(function(item) {
        return companyEditStore_objectSpread({}, item);
    }));
    var locations = _toConsumableArray(document.locations.map(function(item) {
        return companyEditStore_objectSpread({}, item);
    }));
    var references = _toConsumableArray(document.references.map(function(item) {
        return companyEditStore_objectSpread({}, item);
    }));
    return companyEditStore_objectSpread({}, document, selectFields, {
        contactPersons: contactPersons,
        locations: locations,
        references: references
    });
};

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(67265);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItem/ListItem.js
var ListItem = __webpack_require__(50998);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemAvatar/ListItemAvatar.js
var ListItemAvatar = __webpack_require__(96353);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemSecondaryAction/ListItemSecondaryAction.js
var ListItemSecondaryAction = __webpack_require__(81860);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(95757);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/mdi-react/PencilIcon.js
var PencilIcon = __webpack_require__(79367);
var PencilIcon_default = /*#__PURE__*/__webpack_require__.n(PencilIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/DeleteIcon.js
var DeleteIcon = __webpack_require__(83888);
var DeleteIcon_default = /*#__PURE__*/__webpack_require__.n(DeleteIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/ArrowUpIcon.js
var ArrowUpIcon = __webpack_require__(48399);
var ArrowUpIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowUpIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/ArrowDownIcon.js
var ArrowDownIcon = __webpack_require__(64553);
var ArrowDownIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowDownIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/PlusIcon.js
var PlusIcon = __webpack_require__(22467);
var PlusIcon_default = /*#__PURE__*/__webpack_require__.n(PlusIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/InfoOutlineIcon.js
var InfoOutlineIcon = __webpack_require__(2072);
var InfoOutlineIcon_default = /*#__PURE__*/__webpack_require__.n(InfoOutlineIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/EyeIcon.js
var EyeIcon = __webpack_require__(59031);
var EyeIcon_default = /*#__PURE__*/__webpack_require__.n(EyeIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/EyeOffIcon.js
var EyeOffIcon = __webpack_require__(31926);
var EyeOffIcon_default = /*#__PURE__*/__webpack_require__.n(EyeOffIcon);
;// CONCATENATED MODULE: ./components/company/EditListItem.tsx




















function EditListItem_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function EditListItem_templateObject() {
    var data = EditListItem_taggedTemplateLiteral([
        "\n  color: #fe8522;\n  display: flex;\n  > * {\n    vertical-align: top;\n    margin-right: 5px;\n  }\n"
    ]);
    EditListItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var ImportedLocationInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-274bcb28-0"
})(EditListItem_templateObject());
/**
 * List item with move, edit & remove buttons built in
 */ var EditListItem = function(param) {
    var id = param.id, title = param.title, _subtitle = param.subtitle, subtitle = _subtitle === void 0 ? null : _subtitle, icon = param.icon, disableEditing = param.disableEditing, isHidden = param.isHidden, onToggleIsHidden = param.onToggleIsHidden, onMove = param.onMove, onRemove = param.onRemove, onEdit = param.onEdit;
    var intl = (0,useIntl/* default */.Z)();
    var hideShowLabel = !!isHidden ? intl.formatMessage({
        id: 'company.edit.show',
        defaultMessage: 'N\xe4yt\xe4'
    }) : intl.formatMessage({
        id: 'company.edit.hide',
        defaultMessage: 'Piilota'
    });
    var moveUpLabel = intl.formatMessage({
        id: 'company.edit.moveUpButton',
        defaultMessage: 'siirr\xe4 ylemm\xe4s'
    });
    var moveDownLabel = intl.formatMessage({
        id: 'company.edit.moveDownButton',
        defaultMessage: 'siirr\xe4 alemmas'
    });
    var editLabel = intl.formatMessage({
        id: 'company.edit.editButton',
        defaultMessage: 'muokkaa'
    });
    var removeLabel = intl.formatMessage({
        id: 'company.edit.removeButton',
        defaultMessage: 'poista'
    });
    var handleToggleIsHidden = (0,react.useCallback)(function() {
        return onToggleIsHidden && onToggleIsHidden(id);
    }, [
        id,
        onToggleIsHidden
    ]);
    var handleMoveUp = (0,react.useCallback)(function() {
        return onMove && onMove(id, 1);
    }, [
        id,
        onMove
    ]);
    var handleMoveDown = (0,react.useCallback)(function() {
        return onMove && onMove(id, -1);
    }, [
        id,
        onMove
    ]);
    var handleEdit = (0,react.useCallback)(function() {
        return onEdit && onEdit(id);
    }, [
        id,
        onEdit
    ]);
    var handleRemove = (0,react.useCallback)(function() {
        return !onToggleIsHidden && onRemove(id);
    }, [
        id,
        onRemove
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
        disableGutters: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemAvatar/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    children: icon
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                primary: title,
                secondary: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: subtitle
                        }),
                        !!onToggleIsHidden && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImportedLocationInfo, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((InfoOutlineIcon_default()), {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "company.edit.importedLocation",
                                    defaultMessage: "Haettu rekisterist\xe4"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemSecondaryAction/* default */.Z, {
                children: [
                    onMove && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        "aria-label": moveUpLabel,
                        onClick: handleMoveUp,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowUpIcon_default()), {})
                    }),
                    onMove && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        "aria-label": moveDownLabel,
                        onClick: handleMoveDown,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowDownIcon_default()), {})
                    }),
                    !disableEditing && onEdit && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                        title: "Muokkaa",
                        placement: "left",
                        arrow: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            "aria-label": editLabel,
                            onClick: handleEdit,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((PencilIcon_default()), {})
                        })
                    }),
                    onToggleIsHidden && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                        title: hideShowLabel,
                        placement: "top",
                        arrow: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            "aria-label": hideShowLabel,
                            onClick: handleToggleIsHidden,
                            children: !isHidden ? /*#__PURE__*/ (0,jsx_runtime.jsx)((EyeIcon_default()), {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)((EyeOffIcon_default()), {
                                style: {
                                    color: '#ccc'
                                }
                            })
                        })
                    }),
                    onRemove && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                        title: "Poista",
                        placement: "right",
                        arrow: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            edge: "end",
                            "aria-label": removeLabel,
                            onClick: handleRemove,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((DeleteIcon_default()), {
                                color: Theme/* Color.red */.Il.red
                            })
                        })
                    })
                ]
            })
        ]
    }));
};
var EditListCreateButton = function(param) {
    var onClick = param.onClick;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
        disableGutters: true,
        button: true,
        style: {
            borderRadius: Theme/* borderRadius */.E0
        },
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemAvatar/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    style: {
                        background: 'transparent'
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((PlusIcon_default()), {
                        color: Theme/* Color.primary */.Il.primary
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                primary: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "company.location.createButton",
                    defaultMessage: "Luo uusi"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/company/useEditList.ts

function useEditList_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useEditList_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return useEditList_arrayLikeToArray(arr);
}
function useEditList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useEditList_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function useEditList_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useEditList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useEditList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function useEditList_toConsumableArray(arr) {
    return useEditList_arrayWithoutHoles(arr) || useEditList_iterableToArray(arr) || useEditList_unsupportedIterableToArray(arr) || useEditList_nonIterableSpread();
}
function useEditList_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useEditList_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useEditList_arrayLikeToArray(o, minLen);
}
/**
 * Helpers to mutate company edit item lists, like contacts & locations
 */ var useEditList = function(param1) {
    var list = param1.list, keyColumn = param1.keyColumn, emptyItem = param1.emptyItem, removeConfirmationText = param1.removeConfirmationText, setList = param1.setList;
    var move = (0,react.useCallback)(function(id, direction) {
        var deletedItems = list.filter(function(param) {
            var isDeleted = param.isDeleted;
            return isDeleted;
        });
        var existingItems = list.filter(function(param) {
            var isDeleted = param.isDeleted;
            return !isDeleted;
        });
        var one = existingItems.findIndex(function(item) {
            return item[keyColumn] === id;
        });
        var two = one - direction;
        if (two >= existingItems.length || two < 0) return;
        // Swap array items
        var ul = useEditList_toConsumableArray(existingItems);
        var ref;
        ref = [
            ul[two],
            ul[one]
        ], ul[one] = ref[0], ul[two] = ref[1], ref;
        return setList(useEditList_toConsumableArray(ul).concat(useEditList_toConsumableArray(deletedItems)));
    }, [
        list
    ]);
    var remove = (0,react.useCallback)(function(id) {
        var isConfirmed = window.confirm(removeConfirmationText);
        if (!isConfirmed) return;
        var index = list.findIndex(function(item) {
            return item[keyColumn] === id;
        });
        // Remove item
        var ul = useEditList_toConsumableArray(list);
        ul[index].isDeleted = true;
        return setList(ul);
    }, [
        removeConfirmationText,
        list
    ]);
    var create = (0,react.useCallback)(function() {
        var item = useEditList_objectSpread({}, emptyItem, useEditList_defineProperty({}, keyColumn, -list.length));
        setList(useEditList_toConsumableArray(list).concat([
            item
        ]));
        return item;
    }, [
        emptyItem,
        list
    ]);
    var toggleIsHidden = (0,react.useCallback)(function(id) {
        var newList = useEditList_toConsumableArray(list);
        var index = list.findIndex(function(item) {
            return item[keyColumn] === id;
        });
        newList[index].isHidden = !newList[index].isHidden;
        return setList(newList);
    }, [
        list
    ]);
    return {
        toggleIsHidden: toggleIsHidden,
        move: move,
        remove: remove,
        create: create
    };
};

;// CONCATENATED MODULE: ./components/company/EditContactPerson.tsx















function EditContactPerson_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function EditContactPerson_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return EditContactPerson_arrayLikeToArray(arr);
}
function EditContactPerson_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function EditContactPerson_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function EditContactPerson_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function EditContactPerson_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            EditContactPerson_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function EditContactPerson_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = EditContactPerson_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function EditContactPerson_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function EditContactPerson_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function EditContactPerson_toConsumableArray(arr) {
    return EditContactPerson_arrayWithoutHoles(arr) || EditContactPerson_iterableToArray(arr) || EditContactPerson_unsupportedIterableToArray(arr) || EditContactPerson_nonIterableSpread();
}
function EditContactPerson_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return EditContactPerson_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return EditContactPerson_arrayLikeToArray(o, minLen);
}
function EditContactPerson_templateObject() {
    var data = EditContactPerson_taggedTemplateLiteral([
        "\n  overflow-y: auto;\n\n  .MuiFormControl-root {\n    margin-top: 1rem;\n    margin-bottom: 0.5rem;\n  }\n"
    ]);
    EditContactPerson_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Form = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e6b3b990-0"
})(EditContactPerson_templateObject());
var EditContactPersonItem = function(_param) /*#__PURE__*/ {
    var _contactPerson = _param.contactPerson, contactPersonID = _contactPerson.contactPersonID, firstname = _contactPerson.firstname, lastname = _contactPerson.lastname, title = _contactPerson.title, location = _contactPerson.location, actions = EditContactPerson_objectWithoutProperties(_param, [
        "contactPerson"
    ]);
    return (0,jsx_runtime.jsx)(EditListItem, EditContactPerson_objectSpread({
        id: contactPersonID,
        title: [
            firstname,
            lastname
        ].filter(function(name) {
            return !!name;
        }).join(' '),
        subtitle: [
            title,
            location
        ].filter(function(property) {
            return !!property;
        }).join(', '),
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((AccountIcon_default()), {})
    }, actions));
};

var EditContactPersonView = function(param) {
    var contactPersonID = param.contactPersonID, parentTitle = param.parentTitle, onClose = param.onClose;
    var ref = (0,state/* useScopedState */.S)(companyEditState, [
        'contactPersons'
    ]), contactPersons1 = ref.contactPersons, set = ref.set;
    var contactPerson = contactPersons1.find(function(item) {
        return item.contactPersonID === contactPersonID;
    });
    var handleChange = (0,react.useCallback)(function(field, event) {
        var contactPersons = companyEditState.getState().contactPersons;
        var updatedContactPersons = EditContactPerson_toConsumableArray(contactPersons);
        var index = updatedContactPersons.findIndex(function(item) {
            return item.contactPersonID === contactPersonID;
        });
        updatedContactPersons[index][field] = event.target.value;
        set({
            contactPersons: updatedContactPersons
        });
    }, [
        contactPersonID,
        set
    ]);
    var handleFirstNameChange = (0,react.useCallback)(function(event) {
        return handleChange('firstname', event);
    }, [
        handleChange
    ]);
    var handleLastNameChange = (0,react.useCallback)(function(event) {
        return handleChange('lastname', event);
    }, [
        handleChange
    ]);
    var handleTitleChange = (0,react.useCallback)(function(event) {
        return handleChange('title', event);
    }, [
        handleChange
    ]);
    var handleLocationChange = (0,react.useCallback)(function(event) {
        return handleChange('location', event);
    }, [
        handleChange
    ]);
    var handlePhoneChange = (0,react.useCallback)(function(event) {
        return handleChange('phone', event);
    }, [
        handleChange
    ]);
    var handleEmailChange = (0,react.useCallback)(function(event) {
        return handleChange('email', event);
    }, [
        handleChange
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    color: "primary",
                    startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowLeftIcon_default()), {
                        size: 16,
                        color: Theme/* Color.primary */.Il.primary
                    }),
                    size: "small",
                    onClick: onClose,
                    children: parentTitle
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "company.contactPerson.title",
                    defaultMessage: "Yhteyshenkil\xf6"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "company.contactPerson.firstName",
                            defaultMessage: "Etunimi"
                        }),
                        variant: "outlined",
                        fullWidth: true,
                        value: contactPerson.firstname,
                        onChange: handleFirstNameChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "company.contactPerson.lastName",
                            defaultMessage: "Sukunimi"
                        }),
                        variant: "outlined",
                        fullWidth: true,
                        value: contactPerson.lastname,
                        onChange: handleLastNameChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "company.contactPerson.title",
                            defaultMessage: "Titteli"
                        }),
                        variant: "outlined",
                        fullWidth: true,
                        value: contactPerson.title,
                        onChange: handleTitleChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "company.contactPerson.firstName",
                            defaultMessage: "Sijainti"
                        }),
                        variant: "outlined",
                        fullWidth: true,
                        value: contactPerson.location,
                        onChange: handleLocationChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "company.contactPerson.phone",
                            defaultMessage: "Puhelinnumero"
                        }),
                        variant: "outlined",
                        fullWidth: true,
                        value: contactPerson.phone,
                        onChange: handlePhoneChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "company.contactPerson.email",
                            defaultMessage: "S\xe4hk\xf6postiosoite"
                        }),
                        variant: "outlined",
                        fullWidth: true,
                        value: contactPerson.email,
                        onChange: handleEmailChange
                    })
                ]
            })
        ]
    }));
};
var EditContactPerson = function(param1) {
    var parentTitle = param1.parentTitle, onOpen = param1.onOpen, onClose = param1.onClose;
    var intl = (0,useIntl/* default */.Z)();
    var removeConfirmationText = intl.formatMessage({
        id: 'company.contactPerson.edit.removeConfirmationText',
        defaultMessage: 'Oletko varma ett\xe4 haluat poistaa yhteyshenkil\xf6n?'
    });
    var ref = (0,state/* useScopedState */.S)(companyEditState, [
        'contactPersons'
    ]), contactPersons = ref.contactPersons, set = ref.set;
    var setList = (0,react.useCallback)(function(list) {
        return set({
            contactPersons: list
        });
    }, [
        set
    ]);
    var ref1 = useEditList({
        list: contactPersons,
        keyColumn: 'contactPersonID',
        removeConfirmationText: removeConfirmationText,
        emptyItem: {
            contactPersonID: 0,
            firstname: '',
            lastname: '',
            title: '',
            location: '',
            phone: '',
            email: '',
            isDeleted: false
        },
        setList: setList
    }), move = ref1.move, remove = ref1.remove, create = ref1.create;
    /** Render the actual edit view, will be called by the edit dialog when requested */ var renderEditComponent = (0,react.useCallback)(function(contactPersonID) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(EditContactPersonView, {
            contactPersonID: contactPersonID,
            parentTitle: parentTitle,
            onClose: onClose
        });
    }, [
        parentTitle,
        onClose
    ]);
    var handleEdit = (0,react.useCallback)(function(contactPersonID) {
        onOpen(renderEditComponent(contactPersonID));
    }, [
        renderEditComponent,
        onOpen
    ]);
    var handleCreate = (0,react.useCallback)(function() {
        var contactPersonID = create().contactPersonID;
        onOpen(renderEditComponent(contactPersonID));
    }, [
        create,
        renderEditComponent,
        onOpen
    ]);
    var renderContactPerson = (0,react.useCallback)(function(contactPerson) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(EditContactPersonItem, {
            contactPerson: contactPerson,
            onMove: move,
            onEdit: handleEdit,
            onRemove: remove
        }, contactPerson.contactPersonID);
    }, [
        move,
        remove,
        handleEdit
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* default */.Z, {
        disablePadding: true,
        children: [
            contactPersons.filter(function(param) {
                var isDeleted = param.isDeleted;
                return !isDeleted;
            }).map(renderContactPerson),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EditListCreateButton, {
                onClick: handleCreate
            })
        ]
    }));
};

// EXTERNAL MODULE: ./components/company/CompanyFieldAndHelpers.tsx
var CompanyFieldAndHelpers = __webpack_require__(2971);
// EXTERNAL MODULE: ./components/company/CompanyGrid.tsx
var CompanyGrid = __webpack_require__(66235);
;// CONCATENATED MODULE: ./components/company/EditLocation.tsx















function EditLocation_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function EditLocation_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return EditLocation_arrayLikeToArray(arr);
}
function EditLocation_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function EditLocation_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function EditLocation_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function EditLocation_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            EditLocation_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function EditLocation_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = EditLocation_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function EditLocation_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function EditLocation_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function EditLocation_toConsumableArray(arr) {
    return EditLocation_arrayWithoutHoles(arr) || EditLocation_iterableToArray(arr) || EditLocation_unsupportedIterableToArray(arr) || EditLocation_nonIterableSpread();
}
function EditLocation_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return EditLocation_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return EditLocation_arrayLikeToArray(o, minLen);
}
function EditLocation_templateObject() {
    var data = EditLocation_taggedTemplateLiteral([
        "\n  overflow-y: auto;\n\n  .MuiFormControl-root {\n    margin-top: 1rem;\n    margin-bottom: 0.5rem;\n  }\n"
    ]);
    EditLocation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var EditLocation_Form = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2ecc926-0"
})(EditLocation_templateObject());
var EditLocationItem = function(_param) /*#__PURE__*/ {
    var _location = _param.location, locationID = _location.locationID, name = _location.name, street1 = _location.street1, postalCode = _location.postalCode, city = _location.city, isHidden = _location.isHidden, fonectaID = _location.fonectaID, actions = EditLocation_objectWithoutProperties(_param, [
        "location"
    ]);
    return (0,jsx_runtime.jsx)("div", {
        style: {
            opacity: isHidden ? 0.55 : 1
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditListItem, EditLocation_objectSpread({
            id: locationID,
            title: name,
            subtitle: [
                street1,
                postalCode,
                city
            ].filter(function(property) {
                return !!property;
            }).join(', '),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((MapMarkerIcon_default()), {}),
            disableEditing: !!fonectaID
        }, actions, {
            onToggleIsHidden: !!fonectaID ? actions.onToggleIsHidden : null,
            onRemove: !fonectaID ? actions.onRemove : null,
            isHidden: isHidden
        }))
    });
};

var EditLocationView = function(param) {
    var locationID = param.locationID, parentTitle = param.parentTitle, onClose = param.onClose;
    var ref = (0,state/* useScopedState */.S)(companyEditState, [
        'locations'
    ]), locations1 = ref.locations, set = ref.set;
    var location = locations1.find(function(item) {
        return item.locationID === locationID;
    });
    var handleChange = (0,react.useCallback)(function(field, event) {
        var locations = companyEditState.getState().locations;
        var updatedLocations = EditLocation_toConsumableArray(locations);
        var index = updatedLocations.findIndex(function(item) {
            return item.locationID === locationID;
        });
        updatedLocations[index][field] = event.target.value;
        set({
            locations: updatedLocations
        });
    }, [
        locationID,
        set
    ]);
    var handleNameChange = (0,react.useCallback)(function(event) {
        return handleChange('name', event);
    }, [
        handleChange
    ]);
    var handleStreet1Change = (0,react.useCallback)(function(event) {
        return handleChange('street1', event);
    }, [
        handleChange
    ]);
    var handlePostalCodeChange = (0,react.useCallback)(function(event) {
        return handleChange('postalCode', event);
    }, [
        handleChange
    ]);
    var handleCityChange = (0,react.useCallback)(function(event) {
        return handleChange('city', event);
    }, [
        handleChange
    ]);
    var handlePhoneChange = (0,react.useCallback)(function(event) {
        return handleChange('phone', event);
    }, [
        handleChange
    ]);
    var handleEmailChange = (0,react.useCallback)(function(event) {
        return handleChange('email', event);
    }, [
        handleChange
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    color: "primary",
                    startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowLeftIcon_default()), {
                        size: 16,
                        color: Theme/* Color.primary */.Il.primary
                    }),
                    size: "small",
                    onClick: onClose,
                    children: parentTitle
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "company.location.title",
                    defaultMessage: "Toimipiste"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EditLocation_Form, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "company.location.firstName",
                            defaultMessage: "Nimi"
                        }),
                        variant: "outlined",
                        fullWidth: true,
                        value: location.name,
                        onChange: handleNameChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "company.location.lastName",
                            defaultMessage: "Osoite"
                        }),
                        variant: "outlined",
                        fullWidth: true,
                        value: location.street1,
                        onChange: handleStreet1Change
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "company.location.title",
                            defaultMessage: "Postinumero"
                        }),
                        variant: "outlined",
                        fullWidth: true,
                        value: location.postalCode,
                        onChange: handlePostalCodeChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "company.location.firstName",
                            defaultMessage: "Postitoimipaikka"
                        }),
                        variant: "outlined",
                        fullWidth: true,
                        value: location.city,
                        onChange: handleCityChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "company.location.phone",
                            defaultMessage: "Puhelinnumero"
                        }),
                        variant: "outlined",
                        fullWidth: true,
                        value: location.phone,
                        onChange: handlePhoneChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "company.location.email",
                            defaultMessage: "S\xe4hk\xf6postiosoite"
                        }),
                        variant: "outlined",
                        fullWidth: true,
                        value: location.email,
                        onChange: handleEmailChange
                    })
                ]
            })
        ]
    }));
};
var EditLocation = function(param1) {
    var parentTitle = param1.parentTitle, onOpen = param1.onOpen, onClose = param1.onClose;
    var intl = (0,useIntl/* default */.Z)();
    var removeConfirmationText = intl.formatMessage({
        id: 'company.location.edit.removeConfirmationText',
        defaultMessage: 'Oletko varma ett\xe4 haluat poistaa toimipisteen?'
    });
    var ref = (0,state/* useScopedState */.S)(companyEditState, [
        'locations'
    ]), locations = ref.locations, set = ref.set;
    var setList = (0,react.useCallback)(function(list) {
        return set({
            locations: list
        });
    }, [
        set
    ]);
    var ref1 = useEditList({
        list: locations,
        keyColumn: 'locationID',
        removeConfirmationText: removeConfirmationText,
        emptyItem: {
            fonectaID: null,
            locationID: 0,
            name: '',
            street1: '',
            street2: '',
            postalCode: '',
            city: '',
            country: '',
            phone: '',
            email: '',
            isHidden: false,
            isDeleted: false
        },
        setList: setList
    }), toggleIsHidden = ref1.toggleIsHidden, move = ref1.move, remove = ref1.remove, create = ref1.create;
    /** Render the actual edit view, will be called by the edit dialog when requested */ var renderEditComponent = (0,react.useCallback)(function(locationID) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(EditLocationView, {
            locationID: locationID,
            parentTitle: parentTitle,
            onClose: onClose
        });
    }, [
        parentTitle,
        onClose
    ]);
    var handleEdit = (0,react.useCallback)(function(locationID) {
        onOpen(renderEditComponent(locationID));
    }, [
        renderEditComponent,
        onOpen
    ]);
    var handleCreate = (0,react.useCallback)(function() {
        var locationID = create().locationID;
        onOpen(renderEditComponent(locationID));
    }, [
        create,
        renderEditComponent,
        onOpen
    ]);
    var renderLocation = (0,react.useCallback)(function(location) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(EditLocationItem, {
            location: location,
            onToggleIsHidden: toggleIsHidden,
            onMove: move,
            onEdit: handleEdit,
            onRemove: remove
        }, location.locationID);
    }, [
        toggleIsHidden,
        move,
        remove,
        handleEdit
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* default */.Z, {
            disablePadding: true,
            children: [
                locations.filter(function(param) {
                    var isDeleted = param.isDeleted;
                    return !isDeleted;
                }).map(renderLocation),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EditListCreateButton, {
                    onClick: handleCreate
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/company/CompanyContactInfo.tsx


















function CompanyContactInfo_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CompanyContactInfo_templateObject() {
    var data = CompanyContactInfo_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-wrap: wrap;\n\n    .MuiTypography-h5 {\n      font-size: 1.5rem;\n    }\n\n    p {\n      margin: 0.2rem 0;\n      white-space: pre-line;\n    }\n  "
    ]);
    CompanyContactInfo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyContactInfo_templateObject1() {
    var data = CompanyContactInfo_taggedTemplateLiteral([
        "\n      width: 50%;\n    "
    ]);
    CompanyContactInfo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompanyContactInfo_templateObject2() {
    var data = CompanyContactInfo_taggedTemplateLiteral([
        "\n      width: 100%;\n    "
    ]);
    CompanyContactInfo_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = CompanyContactInfo_taggedTemplateLiteral([
        "\n    display: flex;\n    margin-top: 1rem;\n    width: 33.33%;\n\n    > div:last-child {\n      flex: 1;\n      margin-left: 1rem;\n\n      p {\n        display: flex;\n        align-items: center;\n\n        &:first-of-type {\n          margin-bottom: 0.4rem;\n        }\n\n        svg {\n          margin-right: 0.6rem;\n          width: 16px;\n          height: 16px;\n          opacity: 0.5;\n        }\n      }\n    }\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = CompanyContactInfo_taggedTemplateLiteral([
        "\n      width: 50%;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = CompanyContactInfo_taggedTemplateLiteral([
        "\n      width: 100%;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = CompanyContactInfo_taggedTemplateLiteral([
        "\n    display: flex;\n    margin-top: 1rem;\n    width: 33.33%;\n\n    > div:last-child {\n      flex: 1;\n      margin-left: 1rem;\n\n      p {\n        display: flex;\n        align-items: center;\n\n        &:first-of-type {\n          margin-bottom: 0.4rem;\n        }\n\n        svg {\n          margin-right: 0.6rem;\n          width: 16px;\n          height: 16px;\n          opacity: 0.5;\n        }\n      }\n    }\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = CompanyContactInfo_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-shrink: 0;\n    align-items: center;\n    justify-content: center;\n    width: 64px;\n    height: 64px;\n    border-radius: 50%;\n    background-color: ",
        ";\n\n    svg {\n      color: ",
        ";\n    }\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = CompanyContactInfo_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n\n  > div {\n    margin-top: 1rem;\n    margin-bottom: 0.5rem;\n  }\n\n  > button {\n    margin-bottom: 0.5rem;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
var Styled = {
    Row: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-e88294a1-0"
    })(CompanyContactInfo_templateObject()),
    Address: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-e88294a1-1"
    })(_templateObject3(), Theme/* mediaQuery.medium */.cy.medium((0,styled_components_browser_esm/* css */.iv)(CompanyContactInfo_templateObject1())), Theme/* mediaQuery.small */.cy.small((0,styled_components_browser_esm/* css */.iv)(CompanyContactInfo_templateObject2()))),
    Contact: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-e88294a1-2"
    })(_templateObject6(), Theme/* mediaQuery.medium */.cy.medium((0,styled_components_browser_esm/* css */.iv)(_templateObject4())), Theme/* mediaQuery.small */.cy.small((0,styled_components_browser_esm/* css */.iv)(_templateObject5()))),
    Image: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-e88294a1-3"
    })(_templateObject7(), Theme/* Color.background */.Il.background, Theme/* Color.disabled */.Il.disabled)
};
var EditContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e88294a1-4"
})(_templateObject8());
var CompanyContactInfo = function(param) {
    var company = param.company, editable = param.editable, premium = param.premium, loading = param.loading;
    var contactPersons = company.contactPersons, locations = company.locations;
    var dictionary = (0,CompanyDictionary/* useCompanyDictionary */.F)();
    var isPremiumLoading = premium && loading;
    var isEmpty = !contactPersons.length && !locations.length;
    var renderLocation = function(location, index) {
        var cityString = [
            location.postalCode,
            location.city,
            location.country
        ].filter(function(x) {
            return !!x;
        }).join(', ');
        var addressString = [
            location.street1,
            location.street2,
            cityString
        ].filter(function(x) {
            return !!x;
        }).join('\n');
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Styled.Address, {
            style: {
                opacity: location.isHidden ? 0.4 : 1
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled.Image, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((MapMarkerIcon_default()), {
                        size: 38
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h5",
                            children: location.name
                        }),
                        !!addressString && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            children: addressString
                        }),
                        !!location.phone && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "body2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((PhoneIcon_default()), {}),
                                (!premium || isPremiumLoading) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Skeleton */.Od, {
                                    width: 100,
                                    loading: isPremiumLoading
                                }),
                                premium && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "tel:".concat(location.phone),
                                    children: location.phone
                                })
                            ]
                        }),
                        !!location.email && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "body2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((EmailIcon_default()), {}),
                                (!premium || isPremiumLoading) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Skeleton */.Od, {
                                    width: 100,
                                    loading: isPremiumLoading
                                }),
                                premium && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "mailto:".concat(location.email),
                                    children: location.email
                                })
                            ]
                        })
                    ]
                })
            ]
        }, index));
    };
    var renderContactPerson = function(person, index) {
        var fullNameString = [
            person.firstname,
            person.lastname
        ].filter(function(x) {
            return !!x;
        }).join(' ');
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Styled.Contact, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled.Image, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((AccountIcon_default()), {
                        size: 38
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        !!fullNameString && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h5",
                            children: fullNameString
                        }),
                        !!person.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            children: person.title
                        }),
                        !!person.location && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "body2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((MapMarkerIcon_default()), {}),
                                person.location
                            ]
                        }),
                        !!person.phone && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "body2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((PhoneIcon_default()), {}),
                                (!premium || isPremiumLoading) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Skeleton */.Od, {
                                    width: 100,
                                    loading: isPremiumLoading
                                }),
                                premium && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "tel:".concat(person.phone),
                                    children: person.phone
                                })
                            ]
                        }),
                        !!person.email && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "body2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((EmailIcon_default()), {}),
                                (!premium || isPremiumLoading) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Skeleton */.Od, {
                                    width: 100,
                                    loading: isPremiumLoading
                                }),
                                premium && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "mailto:".concat(person.email),
                                    children: person.email
                                })
                            ]
                        })
                    ]
                })
            ]
        }, index));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Grid */.rj, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyGrid/* Column */.sg, {
            children: [
                isEmpty && editable && /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner/* Banner */.j, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "company.contactInfo.editEmptyMessage",
                        defaultMessage: 'Yrityksell\xe4 ei ole viel\xe4 yht\xe4\xe4n yhteyshenkil\xf6\xe4 tai toimipaikkaa. Paina "Muokkaa" lis\xe4t\xe4ksesi ensimm\xe4isen.'
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyGrid/* Item */.ck, {
                    show: isPremiumLoading || locations.length,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyFieldAndHelpers/* StyledLabel */.ar, {
                            children: [
                                dictionary.locations,
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PremiumIcon/* PremiumIcon */.T, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled.Row, {
                            children: locations.filter(function(l) {
                                return !l.isHidden;
                            }).map(renderLocation)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Spacer */.LZ, {
                    show: isPremiumLoading || locations.length && locations.length
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyGrid/* Item */.ck, {
                    show: isPremiumLoading || contactPersons.length,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyFieldAndHelpers/* StyledLabel */.ar, {
                            children: [
                                dictionary.contactPersons,
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PremiumIcon/* PremiumIcon */.T, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled.Row, {
                            children: contactPersons.map(renderContactPerson)
                        })
                    ]
                })
            ]
        })
    }));
};
var CompanyContactInfoEdit = function(param) {
    var company = param.company, openSelect = param.openSelect, closeSelect = param.closeSelect;
    var intl = (0,useIntl/* default */.Z)();
    var title = intl.formatMessage({
        id: 'company.contactInfo.title',
        defaultMessage: 'Yhteystiedot'
    });
    var dictionary = (0,CompanyDictionary/* useCompanyDictionary */.F)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EditContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* StyledLabel */.ar, {
                        children: dictionary.locations
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EditLocation, {
                        parentTitle: title,
                        onOpen: openSelect,
                        onClose: closeSelect
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* StyledLabel */.ar, {
                        children: dictionary.contactPersons
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EditContactPerson, {
                        parentTitle: title,
                        onOpen: openSelect,
                        onClose: closeSelect
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
// EXTERNAL MODULE: ./node_modules/mdi-react/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(34994);
var ChevronDownIcon_default = /*#__PURE__*/__webpack_require__.n(ChevronDownIcon);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Accordion/Accordion.js + 1 modules
var Accordion = __webpack_require__(9607);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/AccordionSummary/AccordionSummary.js
var AccordionSummary = __webpack_require__(50743);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/AccordionDetails/AccordionDetails.js
var AccordionDetails = __webpack_require__(61201);
;// CONCATENATED MODULE: ./components/company/CompanyEditButton.tsx





function CompanyEditButton_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CompanyEditButton_templateObject() {
    var data = CompanyEditButton_taggedTemplateLiteral([
        "\n  align-self: center;\n  box-shadow: none !important;\n  border-radius: 50px !important;\n\n  &.MuiButton-containedPrimary {\n    color: ",
        ";\n  }\n\n  .MuiCircularProgress-root {\n    margin-left: 5px;\n    margin-right: -5px;\n\n    svg {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    CompanyEditButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var EditButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-e5dc462d-0"
})(CompanyEditButton_templateObject(), Theme/* Color.white */.Il.white, Theme/* Color.white */.Il.white);
var CompanyEditButton = function(param) {
    var onClick = param.onClick;
    var handleButtonClick = function(event) {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(EditButton, {
        variant: "contained",
        color: "default",
        size: "large",
        disableElevation: true,
        onClick: handleButtonClick,
        endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)((PencilIcon_default()), {
            size: 18
        }),
        children: "Muokkaa"
    }));
};

// EXTERNAL MODULE: ./node_modules/mdi-react/DiamondIcon.js
var DiamondIcon = __webpack_require__(87452);
var DiamondIcon_default = /*#__PURE__*/__webpack_require__.n(DiamondIcon);
;// CONCATENATED MODULE: ./components/company/CompanyAccordion.tsx












function CompanyAccordion_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CompanyAccordion_templateObject() {
    var data = CompanyAccordion_taggedTemplateLiteral([
        "\n    &.Mui-expanded .MuiAccordionSummary-content svg {\n      transform: rotate(0);\n    }\n\n    h2 {\n      width: auto;\n      margin: 0.9rem 0 0.9rem 1rem;\n    }\n\n    .MuiAccordionSummary-content {\n      > svg {\n        margin-left: 0.55rem;\n        margin-top: 0.8rem;\n        color: ",
        ";\n\n        transform: rotate(-90deg);\n\n        transition: transform 200ms ease;\n      }\n\n      > div {\n        flex: 1;\n        width: 100%;\n      }\n    }\n  "
    ]);
    CompanyAccordion_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyAccordion_templateObject1() {
    var data = CompanyAccordion_taggedTemplateLiteral([
        "\n    ",
        " {\n      margin-top: 0;\n      padding-top: 0;\n    }\n  "
    ]);
    CompanyAccordion_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var StyledAccordion = (0,withStyles/* default */.Z)({
    root: {
        border: 'none',
        borderTop: "2px solid ".concat(Theme/* Color.background */.Il.background),
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0
        },
        '&:before': {
            display: 'none'
        },
        '&$expanded': {
            margin: 'auto'
        },
        '&.Mui-disabled': {
            backgroundColor: 'transparent'
        }
    },
    expanded: {}
})(Accordion/* default */.Z);
var CompanyAccordion_AccordionDetails = (0,withStyles/* default */.Z)(function(theme) {
    return {
        root: {
            display: 'block',
            padding: 0
        }
    };
})(AccordionDetails/* default */.Z);
var CompanyAccordion_Styled = {
    AccordionSummary: (0,styled_components_browser_esm/* default */.ZP)(AccordionSummary/* default */.Z).withConfig({
        componentId: "sc-297b0c81-0"
    })(CompanyAccordion_templateObject(), Theme/* Color.primary */.Il.primary),
    AccordionDetails: (0,styled_components_browser_esm/* default */.ZP)(CompanyAccordion_AccordionDetails).withConfig({
        componentId: "sc-297b0c81-1"
    })(CompanyAccordion_templateObject1(), CompanyGrid/* Grid */.rj)
};
var CompanyAccordion = function(param) {
    var title = param.title, content = param.content, expanded = param.expanded, editable = param.editable, premium = param.premium, disabled = param.disabled, onChange = param.onChange, onEdit = param.onEdit;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(StyledAccordion, {
        square: true,
        expanded: !!expanded && !disabled,
        disabled: disabled,
        onChange: onChange,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyAccordion_Styled.AccordionSummary, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((ChevronDownIcon_default()), {
                        size: 32,
                        color: disabled ? Theme/* Color.disabled */.Il.disabled : Theme/* Color.primary */.Il.primary
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                        icon: premium && disabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)((DiamondIcon_default()), {
                            color: Theme/* Color.primary */.Il.primary
                        }) : null,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                    !!onEdit && !!editable && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyEditButton, {
                        onClick: onEdit
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyAccordion_Styled.AccordionDetails, {
                children: !disabled && content
            })
        ]
    });
};

// EXTERNAL MODULE: ./lib/utils.ts + 1 modules
var utils = __webpack_require__(26482);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 4 modules
var polished_esm = __webpack_require__(83852);
// EXTERNAL MODULE: ./node_modules/mdi-react/StoreIcon.js
var StoreIcon = __webpack_require__(27131);
var StoreIcon_default = /*#__PURE__*/__webpack_require__.n(StoreIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/ImageIcon.js
var ImageIcon = __webpack_require__(47548);
var ImageIcon_default = /*#__PURE__*/__webpack_require__.n(ImageIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/CheckIcon.js
var CheckIcon = __webpack_require__(24173);
var CheckIcon_default = /*#__PURE__*/__webpack_require__.n(CheckIcon);
;// CONCATENATED MODULE: ./common-react/cropImage.ts

function cropImage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function cropImage_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                cropImage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                cropImage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var createImage = function(url) {
    return new Promise(function(resolve, reject) {
        var image = new Image();
        image.addEventListener('load', function() {
            return resolve(image);
        });
        image.addEventListener('error', function(error) {
            return reject(error);
        });
        image.src = url;
    });
};
var getRadianAngle = function(degreeValue) {
    return degreeValue * Math.PI / 180;
};
/**
 * A simple solution to "contain" an image within a 1:1 ratio canvas and export the scaled result
 */ var getContainedImg = function() {
    var _ref = cropImage_asyncToGenerator(runtime_default().mark(function _callee(imageSrc) {
        var image, canvas, ctx, hRatio, vRatio, ratio, centerShift_x, centerShift_y;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return createImage(imageSrc);
                case 2:
                    image = _ctx.sent;
                    canvas = document.createElement('canvas');
                    ctx = canvas.getContext('2d');
                    canvas.width = 512;
                    canvas.height = 512;
                    hRatio = canvas.width / image.width;
                    vRatio = canvas.height / image.height;
                    ratio = Math.min(hRatio, vRatio);
                    centerShift_x = (canvas.width - image.width * ratio) / 2;
                    centerShift_y = (canvas.height - image.height * ratio) / 2;
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    ctx.drawImage(image, 0, 0, image.width, image.height, centerShift_x, centerShift_y, image.width * ratio, image.height * ratio);
                    return _ctx.abrupt("return", canvas.toDataURL('image/png'));
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getContainedImg(imageSrc) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * This function was adapted from the one in the ReadMe of https://github.com/DominicTobias/react-image-crop
 */ var getCroppedImg = function() {
    var _ref = cropImage_asyncToGenerator(runtime_default().mark(function _callee(imageSrc, pixelCrop) {
        var rotation, image, canvas, ctx, maxSize, safeArea, data, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    rotation = _args.length > 2 && _args[2] !== void 0 ? _args[2] : 0;
                    _ctx.next = 3;
                    return createImage(imageSrc);
                case 3:
                    image = _ctx.sent;
                    canvas = document.createElement('canvas');
                    ctx = canvas.getContext('2d');
                    maxSize = Math.max(image.width, image.height);
                    safeArea = 2 * (maxSize / 2 * Math.sqrt(2));
                    // set each dimensions to double largest dimension to allow for a safe area for the
                    // image to rotate in without being clipped by canvas context
                    canvas.width = safeArea;
                    canvas.height = safeArea;
                    // translate canvas context to a central location on image to allow rotating around the center.
                    ctx.translate(safeArea / 2, safeArea / 2);
                    ctx.rotate(getRadianAngle(rotation));
                    ctx.translate(-safeArea / 2, -safeArea / 2);
                    // draw rotated image and store data.
                    ctx.drawImage(image, safeArea / 2 - image.width * 0.5, safeArea / 2 - image.height * 0.5);
                    data = ctx.getImageData(0, 0, safeArea, safeArea);
                    // set canvas width to final desired crop size - this will clear existing context
                    canvas.width = pixelCrop.width;
                    canvas.height = pixelCrop.height;
                    // paste generated rotate image with correct offsets for x,y crop values.
                    ctx.putImageData(data, Math.round(0 - safeArea / 2 + image.width * 0.5 - pixelCrop.x), Math.round(0 - safeArea / 2 + image.height * 0.5 - pixelCrop.y));
                    return _ctx.abrupt("return", canvas.toDataURL('image/png'));
                case 19:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    // As a blob
    /*
  return new Promise((resolve) => {
      canvas.toBlob((file) => {
      resolve(URL.createObjectURL(file));
    }, 'image/jpeg');
  });
  */ }));
    return function getCroppedImg(imageSrc, pixelCrop) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./components/company-list/CompanyListStyle.tsx
var CompanyListStyle = __webpack_require__(31999);
// EXTERNAL MODULE: ./components/Button.tsx
var components_Button = __webpack_require__(40570);
// EXTERNAL MODULE: ./components/Help.tsx
var Help = __webpack_require__(52433);
// EXTERNAL MODULE: ./node_modules/mdi-react/GetAppIcon.js
var GetAppIcon = __webpack_require__(80715);
var GetAppIcon_default = /*#__PURE__*/__webpack_require__.n(GetAppIcon);
// EXTERNAL MODULE: ./node_modules/react-easy-crop/index.module.js + 1 modules
var index_module = __webpack_require__(66703);
;// CONCATENATED MODULE: ./components/company/CompanyEditImage.tsx









function CompanyEditImage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function CompanyEditImage_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                CompanyEditImage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                CompanyEditImage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function CompanyEditImage_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CompanyEditImage_templateObject() {
    var data = CompanyEditImage_taggedTemplateLiteral([
        "\n  margin: 0.8rem 0;\n\n  > h5 {\n    margin: 0 0 0.5rem 0;\n    font-size: 1rem;\n  }\n\n  > div {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 400px;\n    border: ",
        " 2px ",
        ";\n    border-radius: 4px;\n    background-color: ",
        ";\n    cursor: pointer;\n    user-select: none;\n    box-sizing: border-box;\n\n    transition: border 200ms cubic-bezier(0.4, 0, 0.2, 1);\n\n    &:hover {\n      svg {\n        transform: translateY(0.4rem);\n        fill: ",
        ";\n      }\n    }\n\n    svg {\n      margin: 0 0 2rem 0;\n      width: 5rem;\n      height: 5rem;\n      fill: ",
        ";\n\n      transform: ",
        ";\n\n      transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1), transform 300ms cubic-bezier(0.4, 0, 0.2, 1);\n    }\n\n    * {\n      user-select: none;\n      pointer-events: none;\n    }\n  }\n\n  p {\n    margin: 0.4rem 0 0 0;\n    font-size: 0.7rem;\n    color: ",
        ";\n    opacity: 0.7;\n  }\n\n  input {\n    display: none;\n  }\n"
    ]);
    CompanyEditImage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyEditImage_templateObject1() {
    var data = CompanyEditImage_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0.8rem 0;\n  width: 100%;\n  height: 400px;\n  // background-color: ",
        ";\n  border-radius: 4px;\n  overflow: hidden;\n\n  > div {\n    position: relative;\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    CompanyEditImage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var UploadArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1287241d-0"
})(CompanyEditImage_templateObject(), function(props) {
    return props.isDragOnTop ? 'solid' : 'dashed';
}, function(props) {
    return props.isDragOnTop ? Theme/* Color.primary */.Il.primary : Theme/* Color.disabled */.Il.disabled;
}, Theme/* Color.background */.Il.background, Theme/* Color.primary */.Il.primary, function(props) {
    return props.isDragOnTop ? Theme/* Color.primary */.Il.primary : Theme/* Color.disabled */.Il.disabled;
}, function(props) {
    return props.isDragOnTop ? 'translateY(0.4rem)' : 'translateY(0)';
}, Theme/* Color.black */.Il.black);
var CropContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1287241d-1"
})(CompanyEditImage_templateObject1(), Theme/* Color.background */.Il.background);
var CompanyEditImage = function(param) {
    var onComplete = param.onComplete;
    var ref = (0,react.useState)('select'), step = ref[0], setStep = ref[1];
    var ref1 = (0,react.useState)(false), isDragOnTop = ref1[0], setIsDragOnTop = ref1[1];
    var ref2 = (0,react.useState)({
        x: 0,
        y: 0
    }), crop = ref2[0], setCrop = ref2[1];
    var ref3 = (0,react.useState)(1), zoom = ref3[0], setZoom = ref3[1];
    var ref4 = (0,react.useState)(null), file1 = ref4[0], setFile = ref4[1];
    var fileInputRef = (0,react.useRef)(null);
    var handleFileSelect = function(files) {
        var showError = function(message) {
            // TODO: Implement error
            setIsDragOnTop(false);
        };
        if (!files) return showError('Invalid file selected');
        if (files.length !== 1) return showError('Only one file at a time is allowed');
        var file = files[0];
        if (!file.type.includes('image/')) return showError('Only image files are supported');
        // TODO: We will skip image crop step for now, it was not that intuitive for customers...
        setFile(URL.createObjectURL(file));
        // setStep('crop');
        return onComplete(URL.createObjectURL(file), null);
    };
    var handleUploadFileClick = function() {
        var _ref = CompanyEditImage_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (fileInputRef.current) {
                            fileInputRef.current.click();
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleUploadFileClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleUploadFileChange = function(event) {
        var element = event.target;
        if (!element || !element.files || !element.files.length) return;
        handleFileSelect(element.files);
    };
    var handleDragEnter = function(event) {
        event.preventDefault();
        setIsDragOnTop(true);
    };
    var handleDragLeave = function() {
        setIsDragOnTop(false);
    };
    var handleDragOver = function(event) {
        event.preventDefault();
    };
    var handleDragDrop = function(event) {
        event.stopPropagation();
        event.preventDefault();
        setIsDragOnTop(false);
        handleFileSelect(event.dataTransfer.files);
    };
    var handleImageCrop = function(croppedArea, croppedAreaPixels) {
        onComplete(file1, croppedAreaPixels);
    };
    if (step === 'select') {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(UploadArea, {
            isDragOnTop: isDragOnTop,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: handleUploadFileClick,
                onDragEnter: handleDragEnter,
                onDragLeave: handleDragLeave,
                onDragOver: handleDragOver,
                onDrop: handleDragDrop,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((GetAppIcon_default()), {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "company.image.uploadInfo",
                            defaultMessage: "Tipauta kuvatiedosto t\xe4h\xe4n tai napsauta avataksesi tiedostovalitsimen"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "company.image.uploadFormat",
                            defaultMessage: ".png / .jpg / .jpeg — max 60 Mb"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "file",
                        accept: "image/png,image/jpeg",
                        onChange: handleUploadFileChange,
                        ref: fileInputRef
                    })
                ]
            })
        }));
    }
    if (step === 'crop') {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CropContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* default */.Z, {
                        image: file1,
                        crop: crop,
                        zoom: zoom,
                        aspect: 1,
                        onCropChange: setCrop,
                        onCropComplete: handleImageCrop,
                        onZoomChange: setZoom
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* Help */.W, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "company.image.cropInfo",
                        defaultMessage: "Kuvan rajausta voi muokata liikuttamalla kuvaa hiirell\xe4 tai sormella, sek\xe4 zoomaamalla sis\xe4\xe4n ja ulos k\xe4ytt\xe4en hiiren rullaa tai kahta sormea."
                    })
                })
            ]
        }));
    }
};

;// CONCATENATED MODULE: ./components/company/CompanyImage.tsx






















function CompanyImage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function CompanyImage_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                CompanyImage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                CompanyImage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function CompanyImage_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CompanyImage_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CompanyImage_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CompanyImage_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CompanyImage_templateObject() {
    var data = CompanyImage_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n"
    ]);
    CompanyImage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyImage_templateObject1() {
    var data = CompanyImage_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  width: 6rem;\n  height: 6rem;\n  border-radius: ",
        "px;\n  border: dashed 2px ",
        ";\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  overflow: hidden;\n\n  svg {\n    color: ",
        ";\n  }\n"
    ]);
    CompanyImage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompanyImage_templateObject2() {
    var data = CompanyImage_taggedTemplateLiteral([
        "\n  position: absolute;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-end;\n  padding: 0.5rem;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(225deg, ",
        " 0%, ",
        " 50%);\n  box-sizing: border-box;\n  cursor: pointer;\n\n  svg {\n    color: rgba(0, 0, 0, 0.87);\n  }\n"
    ]);
    CompanyImage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CompanyImage_templateObject3() {
    var data = CompanyImage_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin: 0.8rem 0;\n  padding: 2rem;\n  height: 400px;\n  background-color: ",
        ";\n  border-radius: ",
        "px;\n\n  min-height: 284px;\n\n  ",
        " {\n    margin-top: 2rem;\n    border-radius: ",
        "px !important;\n\n    > div {\n      display: flex;\n      flex: 1;\n      position: relative;\n      align-items: center;\n      border-radius: inherit;\n    }\n  }\n"
    ]);
    CompanyImage_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CompanyImage_templateObject4() {
    var data = CompanyImage_taggedTemplateLiteral([
        "\n  width: 200px;\n  height: 200px;\n  background-color: white;\n  border-radius: ",
        "px;\n"
    ]);
    CompanyImage_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CompanyImage_templateObject5() {
    var data = CompanyImage_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n\n  ",
        " {\n    flex: none !important;\n  }\n\n  > div {\n    flex: 1;\n    padding-left: 2rem;\n\n    span:first-child {\n      margin-top: -0.5rem;\n      margin-bottom: 0.5rem;\n      font-size: 2.8rem;\n    }\n  }\n"
    ]);
    CompanyImage_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
var CompanyImage_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fa2d8ce3-0"
})(CompanyImage_templateObject());
var CompanyImage_Image = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fa2d8ce3-1"
})(CompanyImage_templateObject1(), Theme/* borderRadius */.E0, (0,polished_esm/* darken */._j)(0.1, Theme/* Color.background */.Il.background), (0,polished_esm/* darken */._j)(0.2, Theme/* Color.background */.Il.background));
var ImageEdit = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fa2d8ce3-2"
})(CompanyImage_templateObject2(), Theme/* Color.disabled */.Il.disabled, (0,polished_esm/* transparentize */.DZ)(1, Theme/* Color.disabled */.Il.disabled));
var PreviewContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fa2d8ce3-3"
})(CompanyImage_templateObject3(), Theme/* Color.background */.Il.background, Theme/* borderRadius */.E0, CompanyListStyle/* Row */.X2, Theme/* borderRadius */.E0);
var PreviewImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-fa2d8ce3-4"
})(CompanyImage_templateObject4(), Theme/* borderRadius */.E0);
/** Simulate the company page hero */ var CompanyImage_Hero = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fa2d8ce3-5"
})(CompanyImage_templateObject5(), CompanyImage_Image);
var CompanyImage = function(param) {
    var company = param.company, editable = param.editable, onEdit = param.onEdit;
    var logo = company.logo;
    var hasLogo = logo && logo.path;
    var styleProp = {};
    if (hasLogo) {
        styleProp = {
            backgroundImage: "url(/api/v1/files/public/96x96M-".concat(logo.path, ")"),
            backgroundColor: 'white',
            border: 'none'
        };
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyImage_Image, {
        style: CompanyImage_objectSpread({}, styleProp),
        children: [
            !hasLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)((StoreIcon_default()), {
                size: 64
            }),
            editable && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageEdit, {
                onClick: onEdit,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((PencilIcon_default()), {
                    size: 18
                })
            })
        ]
    }));
};
var convertDataURIToBlob = function(dataURI) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    var byteString = atob(dataURI.split(',')[1]);
    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length);
    // create a view into the buffer
    var ia = new Uint8Array(ab);
    // set the bytes of the buffer to the correct values
    for(var i = 0; i < byteString.length; i++){
        ia[i] = byteString.charCodeAt(i);
    }
    // write the ArrayBuffer to a blob, and you're done
    var blob = new Blob([
        ab
    ], {
        type: mimeString
    });
    return blob;
};
var CompanyImageEdit = function(param) {
    var company = param.company, disableSave = param.disableSave, setControl = param.setControl, setError = param.setError, close = param.close, save = param.save;
    var intl = (0,useIntl/* default */.Z)();
    var title = intl.formatMessage({
        id: 'company.imageTitle',
        defaultMessage: 'Logo'
    });
    var ref4 = (0,react.useState)('select'), step = ref4[0], setStep = ref4[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(null), cropState = ref2[0], setCropState = ref2[1];
    var ref3 = (0,react.useState)(null), image1 = ref3[0], setImage = ref3[1];
    var set = (0,state/* useScopedState */.S)(companyEditState, []).set;
    var handleImageUpload = (0,react.useCallback)(CompanyImage_asyncToGenerator(runtime_default().mark(function _callee() {
        var blob, ref, uploadStatus, fileID, path;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    setIsLoading(true);
                    blob = convertDataURIToBlob(image1);
                    _ctx.next = 4;
                    return (0,utils/* sendFile */.kB)(blob, function() {}, '/api/v1/www/file/upload');
                case 4:
                    ref = _ctx.sent;
                    uploadStatus = ref.status;
                    fileID = ref.fileID;
                    path = ref.path;
                    if (!(uploadStatus !== 'ok' || !fileID)) {
                        _ctx.next = 11;
                        break;
                    }
                    setIsLoading(false);
                    return _ctx.abrupt("return", setError(/*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "unknownError",
                        defaultMessage: "Jokin meni vikaan, yrit\xe4 my\xf6hemmin uudelleen…"
                    })));
                case 11:
                    set({
                        logo: {
                            fileID: fileID,
                            path: path
                        }
                    });
                    _ctx.next = 14;
                    return save();
                case 14:
                    setIsLoading(false);
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        image1
    ]);
    (0,react.useEffect)(function() {
        setControl(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* Button */.z, {
                    disabled: isLoading,
                    variant: "text",
                    color: "default",
                    onClick: close,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "company.edit.cancelButton",
                        defaultMessage: "Peruuta"
                    })
                }),
                step !== 'preview' && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* Button */.z, {
                    disabled: !cropState || isLoading,
                    onClick: handleCropComplete,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "company.edit.nextButton",
                        defaultMessage: "Seuraava"
                    })
                }),
                step === 'preview' && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* Button */.z, {
                    disabled: !cropState || isLoading,
                    loading: isLoading,
                    endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)((CheckIcon_default()), {}),
                    onClick: handleImageUpload,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "company.edit.saveButton",
                        defaultMessage: "Tallenna"
                    })
                })
            ]
        }));
    }, [
        step,
        cropState,
        isLoading,
        handleImageUpload
    ]);
    var handleCropComplete = function() {
        var _ref = CompanyImage_asyncToGenerator(runtime_default().mark(function _callee() {
            var image;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (cropState) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        image = null;
                        if (!cropState.crop) {
                            _ctx.next = 9;
                            break;
                        }
                        _ctx.next = 6;
                        return getCroppedImg(cropState.image, cropState.crop);
                    case 6:
                        image = _ctx.sent;
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.next = 11;
                        return getContainedImg(cropState.image);
                    case 11:
                        image = _ctx.sent;
                    case 12:
                        setImage(image);
                        setStep('preview');
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCropComplete() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCropChange = function(image, crop) {
        setCropState({
            image: image,
            crop: crop
        });
    };
    // TODO: Cropping state is disabled for now, skip it
    (0,react.useEffect)(function() {
        handleCropComplete();
    }, [
        cropState
    ]);
    var imgStyle = {
        backgroundImage: "url(".concat(image1, ")"),
        backgroundColor: 'white',
        border: 'none'
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyImage_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((ImageIcon_default()), {}),
                children: title
            }),
            step === 'select' && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyEditImage, {
                onComplete: handleCropChange
            }),
            step === 'preview' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PreviewContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyImage_Hero, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyImage_Image, {
                                        style: imgStyle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                animation: false,
                                                width: "100%"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                animation: false,
                                                width: "40%"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyListStyle/* Row */.X2, {
                                small: true,
                                style: {
                                    width: '100%'
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyListStyle/* Logo */.TR, {
                                            style: imgStyle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyListStyle/* Section */.$0, {
                                            flex: true,
                                            width: null,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        animation: false,
                                                        width: "80%"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "body2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        animation: false,
                                                        width: "30%"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* Help */.W, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "company.image.previewInfo",
                            defaultMessage: "Tarkista, n\xe4ytt\xe4\xe4k\xf6 kuva hyv\xe4lt\xe4. T\xe4ss\xe4 esimerkit kahdesta yleisimm\xe4st\xe4 n\xe4kym\xe4st\xe4 mihin logo upotetaan."
                        })
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/mdi-react/AccountMultipleIcon.js
var AccountMultipleIcon = __webpack_require__(16450);
var AccountMultipleIcon_default = /*#__PURE__*/__webpack_require__.n(AccountMultipleIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/TrendingUpIcon.js
var TrendingUpIcon = __webpack_require__(34989);
var TrendingUpIcon_default = /*#__PURE__*/__webpack_require__.n(TrendingUpIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/MapSearchIcon.js
var MapSearchIcon = __webpack_require__(9961);
var MapSearchIcon_default = /*#__PURE__*/__webpack_require__.n(MapSearchIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/OpenInNewIcon.js
var OpenInNewIcon = __webpack_require__(28879);
var OpenInNewIcon_default = /*#__PURE__*/__webpack_require__.n(OpenInNewIcon);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(23855);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 26 modules
var format = __webpack_require__(40929);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isValid/index.js + 1 modules
var isValid = __webpack_require__(61436);
// EXTERNAL MODULE: ./common/constleUtils.ts
var constleUtils = __webpack_require__(45521);
// EXTERNAL MODULE: ./context/advancedSearchStore.ts
var advancedSearchStore = __webpack_require__(94322);
// EXTERNAL MODULE: ./node_modules/mdi-react/FormatListBulletedSquareIcon.js
var FormatListBulletedSquareIcon = __webpack_require__(46457);
var FormatListBulletedSquareIcon_default = /*#__PURE__*/__webpack_require__.n(FormatListBulletedSquareIcon);
// EXTERNAL MODULE: ./components/Badge.tsx
var Badge = __webpack_require__(44632);
;// CONCATENATED MODULE: ./components/company/CompanyEditListButton.tsx







function CompanyEditListButton_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CompanyEditListButton_templateObject() {
    var data = CompanyEditListButton_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-shrink: 0;\n    align-items: center;\n    position: relative;\n    padding: 0 1rem 0 1rem;\n    height: 56px;\n    font-size: 1.06rem;\n    font-weight: ",
        ";\n    font-family: 'Roboto', sans-serif;\n    background: none;\n    background-color: ",
        ";\n    border-radius: ",
        "px;\n    border: none;\n    outline: none;\n    color: ",
        ";\n\n    cursor: pointer;\n\n    &::after {\n      content: '';\n      display: block;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      border: 2px solid transparent;\n      border-radius: inherit;\n\n      box-sizing: border-box;\n    }\n\n    &:hover {\n      // background-color: ",
        ";\n\n      &::after {\n        border-color: ",
        ";\n      }\n    }\n\n    &:focus,\n    &:active {\n      background-color: ",
        ";\n\n      &::after {\n        border-color: ",
        ";\n      }\n    }\n\n    > span.spacer {\n      flex: 1;\n    }\n\n    > svg {\n      margin-left: 0.2rem;\n      color: ",
        ";\n\n      &:first-child {\n        margin-left: 0rem;\n        margin-right: 0.6rem;\n        color: ",
        ";\n        opacity: 0.4;\n      }\n    }\n\n    .badge {\n      margin-right: 1rem;\n      margin-left: 0.5rem;\n      font-weight: normal;\n    }\n  "
    ]);
    CompanyEditListButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var CompanyEditListButton_Styled = {
    Button: styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
        componentId: "sc-2ccd85dd-0"
    })(CompanyEditListButton_templateObject(), function(param) {
        var primary = param.primary;
        return primary ? 500 : 'bold';
    }, Theme/* Color.background */.Il.background, Theme/* borderRadius */.E0, Theme/* Color.black */.Il.black, Theme/* Color.hover */.Il.hover, Theme/* Color.secondary */.Il.secondary, function(param) {
        var primary = param.primary;
        return primary ? (0,polished_esm/* darken */._j)(0.1, Theme/* Color.primary */.Il.primary) : Theme/* Color.select */.Il.select;
    }, Theme/* Color.primary */.Il.primary, Theme/* Color.primary */.Il.primary, Theme/* Color.black */.Il.black)
};
var CompanyEditListButton = function(param) {
    var icon = param.icon, _count = param.count, count = _count === void 0 ? 0 : _count, _primary = param.primary, primary = _primary === void 0 ? false : _primary, _className = param.className, className = _className === void 0 ? '' : _className, onClick = param.onClick, children = param.children;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(CompanyEditListButton_Styled.Button, {
        className: className,
        primary: primary,
        onClick: onClick,
        children: [
            icon || /*#__PURE__*/ (0,jsx_runtime.jsx)((FormatListBulletedSquareIcon_default()), {}),
            " ",
            children,
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "spacer"
            }),
            " ",
            count > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                children: count
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)((PencilIcon_default()), {})
        ]
    });
};

// EXTERNAL MODULE: ./components/select/ListSelect.tsx
var ListSelect = __webpack_require__(62653);
;// CONCATENATED MODULE: ./components/company/CompanyEditSelect.tsx









function CompanyEditSelect_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CompanyEditSelect_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CompanyEditSelect_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CompanyEditSelect_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = CompanyEditSelect_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function CompanyEditSelect_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var CompanyEditSelectComponent = function(param) {
    var id = param.id, parentTitle = param.parentTitle, title = param.title, items = param.items, selected = param.selected, onSelect = param.onSelect, onClose = param.onClose;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    color: "primary",
                    startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowLeftIcon_default()), {
                        size: 16,
                        color: Theme/* Color.primary */.Il.primary
                    }),
                    size: "small",
                    onClick: onClose,
                    children: parentTitle
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListSelect/* ListSelect */.H, {
                id: id,
                selected: selected,
                onSelect: onSelect,
                showCount: true,
                items: items
            })
        ]
    }));
};
var CompanyEditSelect = function(props) {
    var title = props.title, path = props.path, onOpen = props.onOpen;
    var _ref = (0,state/* useScopedState */.S)(companyEditState, [
        path
    ]), set = _ref.set, editState = CompanyEditSelect_objectWithoutProperties(_ref, [
        "set"
    ]);
    var _path = editState[path], selected1 = _path.selected, count1 = _path.count;
    // Unique ID for the select component
    var id = "company-edit-".concat(path);
    var handleSelect = function(param) {
        var selected = param.selected, count = param.count;
        set(CompanyEditSelect_defineProperty({}, path, {
            selected: selected,
            count: count
        }));
    };
    /** Render the actual select component, will be called by the edit dialog when requested */ var renderSelectComponent = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(CompanyEditSelectComponent, CompanyEditSelect_objectSpread({
            id: id,
            selected: selected1,
            onSelect: handleSelect
        }, props));
    };
    var handleEditButtonClick = function() {
        onOpen(renderSelectComponent());
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyEditListButton, {
        count: count1,
        onClick: handleEditButtonClick,
        children: title
    }));
};
/**
 * Render a button that when clicked opens a select component for editing
 */ 

;// CONCATENATED MODULE: ./components/company/CompanyBasicInfo.tsx























function CompanyBasicInfo_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CompanyBasicInfo_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CompanyBasicInfo_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CompanyBasicInfo_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CompanyBasicInfo_templateObject() {
    var data = CompanyBasicInfo_taggedTemplateLiteral([
        "\n  min-height: 30.7px; // This is to make the height of the quote column the same as the turnover column\n  white-space: pre;\n  white-space: pre-wrap; /* css-3 */\n  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */\n  white-space: -pre-wrap; /* Opera 4-6 */\n  white-space: -o-pre-wrap; /* Opera 7 */\n  word-wrap: break-word;\n\n  word-break: break-all;\n  word-break: break-word;\n"
    ]);
    CompanyBasicInfo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var LargeQuote = (0,styled_components_browser_esm/* default */.ZP)(CompanyFieldAndHelpers/* Quote */.pu).withConfig({
    componentId: "sc-bbdda655-0"
})(CompanyBasicInfo_templateObject());
var CompanyBasicInfo = function(param) {
    var company = param.company, premium = param.premium, loading = param.loading, editable = param.editable, onEdit = param.onEdit;
    var dictionary = (0,CompanyDictionary/* useCompanyDictionary */.F)();
    var isLanguagesIDSelected = (0,advancedSearchStore/* useCheckSelectedID */.Tw)('languages');
    var name = company.name, email = company.email, description = company.description, dateEstablished = company.dateEstablished, homepage = company.homepage, languages = company.languages, numberOfEmployees = company.numberOfEmployees, turnover = company.turnover, domicile = company.domicile, references = company.references;
    var commonFieldProps = {
        premium: premium,
        loading: loading
    };
    var numberOfEmployeesString = (0,constleUtils/* formatMinMax */.m8)(numberOfEmployees);
    var turnoverString = (0,constleUtils/* formatMinMax */.m8)(turnover);
    var domicileString = [
        (domicile === null || domicile === void 0 ? void 0 : domicile.cityName) || '',
        (domicile === null || domicile === void 0 ? void 0 : domicile.provinceName) || ''
    ].filter(function(x) {
        return !!x;
    }).join(', ');
    var dateEstablishedDate = (0,parseISO/* default */.Z)(dateEstablished);
    // if established in previous year or later, show month
    var previousYear = new Date().getFullYear() - 1;
    var establishedMonthOrEmpty = company.dateEstablished && new Date(company.dateEstablished).getFullYear() >= previousYear ? (0,format/* default */.Z)((0,parseISO/* default */.Z)(company.dateEstablished), 'M') + '/' : '';
    var dateEstablishedString = (0,isValid/* default */.Z)(dateEstablishedDate) ? establishedMonthOrEmpty + (0,format/* default */.Z)((0,parseISO/* default */.Z)(company.dateEstablished), 'yyyy') : '';
    var isPremiumLoading = premium && loading;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyGrid/* BasicInfoGrid */.KH, {
        children: [
            !!onEdit && !!editable && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyEditButton, {
                onClick: onEdit
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyGrid/* Column */.sg, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Item */.ck, {
                        show: editable || description,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Field */.gN, CompanyBasicInfo_objectSpread({
                            label: dictionary.description
                        }, commonFieldProps, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LargeQuote, {
                                children: description
                            })
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Spacer */.LZ, {
                        show: editable || description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyGrid/* Grid */.rj, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Column */.sg, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Item */.ck, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyFieldAndHelpers/* Field */.gN, CompanyBasicInfo_objectSpread({
                                        label: dictionary.numberOfEmployees
                                    }, commonFieldProps, {
                                        large: true,
                                        empty: !numberOfEmployeesString,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((AccountMultipleIcon_default()), {
                                                color: Theme/* Color.disabled */.Il.disabled,
                                                size: 24
                                            }),
                                            " ",
                                            numberOfEmployeesString
                                        ]
                                    }))
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Column */.sg, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Item */.ck, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyFieldAndHelpers/* Field */.gN, CompanyBasicInfo_objectSpread({
                                        label: dictionary.turnover,
                                        large: true
                                    }, commonFieldProps, {
                                        empty: !turnoverString,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((TrendingUpIcon_default()), {
                                                color: Theme/* Color.disabled */.Il.disabled,
                                                size: 24
                                            }),
                                            " ",
                                            turnoverString
                                        ]
                                    }))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Spacer */.LZ, {
                        show: editable || description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Item */.ck, {
                        show: editable || languages.length,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Field */.gN, CompanyBasicInfo_objectSpread({
                            label: dictionary.languages
                        }, commonFieldProps, {
                            chip: true,
                            empty: !languages.length,
                            children: languages.map(function(l, i) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Chip */.Af, {
                                    selected: isLanguagesIDSelected(l.languageID),
                                    children: l.nameTranslations['fi'] || l.name
                                }, l.languageID);
                            })
                        }))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyGrid/* Column */.sg, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyGrid/* Grid */.rj, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Column */.sg, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Item */.ck, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Field */.gN, CompanyBasicInfo_objectSpread({
                                        label: dictionary.name,
                                        empty: !name
                                    }, commonFieldProps, {
                                        children: name
                                    }))
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Column */.sg, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Item */.ck, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Field */.gN, CompanyBasicInfo_objectSpread({
                                        label: dictionary.dateEstablished,
                                        empty: !dateEstablishedString
                                    }, commonFieldProps, {
                                        children: dateEstablishedString
                                    }))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Item */.ck, {
                        show: domicileString,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyFieldAndHelpers/* Field */.gN, CompanyBasicInfo_objectSpread({
                            label: dictionary.domicile
                        }, commonFieldProps, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: domicileString
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    rel: "noopener",
                                    "aria-label": "google maps",
                                    href: "https://www.google.com/maps/search/?api=1&query=".concat(domicileString),
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((MapSearchIcon_default()), {
                                        size: 18,
                                        color: Theme/* Color.primary */.Il.primary
                                    })
                                })
                            ]
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Item */.ck, {
                        show: editable || isPremiumLoading || !premium || email,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Field */.gN, CompanyBasicInfo_objectSpread({
                            label: dictionary.email,
                            premiumOnly: true
                        }, commonFieldProps, {
                            empty: !email,
                            children: email
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Item */.ck, {
                        show: editable || homepage,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Field */.gN, CompanyBasicInfo_objectSpread({
                            label: dictionary.homepage
                        }, commonFieldProps, {
                            empty: !homepage,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: 'https://' + homepage,
                                target: "_blank",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: homepage
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((OpenInNewIcon_default()), {
                                        size: 18,
                                        color: Theme/* Color.disabled */.Il.disabled
                                    })
                                ]
                            })
                        }))
                    })
                ]
            })
        ]
    }));
};
var CompanyBasicInfoEdit = function(param) {
    var company = param.company, openSelect = param.openSelect, closeSelect = param.closeSelect;
    var intl = (0,useIntl/* default */.Z)();
    var title = intl.formatMessage({
        id: 'company.basicInfoTitle',
        defaultMessage: 'Perustiedot'
    });
    var dictionary = (0,CompanyDictionary/* useCompanyDictionary */.F)();
    var ref = (0,state/* useScopedState */.S)(companyEditState, [
        'numberOfEmployees'
    ]), numberOfEmployees = ref.numberOfEmployees, set = ref.set;
    var languages = (0,state/* useScopedState */.S)(staticStore/* staticState */.G, [
        'languages'
    ]).languages;
    var descriptionField = (0,state/* useFieldState */.t)(companyEditState, 'description');
    var emailField = (0,state/* useFieldState */.t)(companyEditState, 'email');
    var homepageField = (0,state/* useFieldState */.t)(companyEditState, 'homepage');
    var handleNumberOfEmployeesChange = function(event) {
        var value = parseInt(event.target.value) || 0;
        set({
            numberOfEmployees: {
                min: value,
                max: value
            }
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, CompanyBasicInfo_objectSpread({
                label: dictionary.description,
                variant: "outlined",
                fullWidth: true,
                multiline: true,
                rows: 4
            }, descriptionField)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* Help */.W, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "company.description.helpText",
                    defaultMessage: "Yritysesittely kiteytt\xe4\xe4 yrityksesi toiminnan ja tavoitteet muutamaan virkkeeseen"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                label: dictionary.numberOfEmployees,
                variant: "outlined",
                type: "number",
                fullWidth: true,
                InputProps: {
                    inputProps: {
                        min: 0
                    }
                },
                value: numberOfEmployees.min,
                onChange: handleNumberOfEmployeesChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, CompanyBasicInfo_objectSpread({
                label: dictionary.email,
                variant: "outlined",
                type: "email",
                fullWidth: true
            }, emailField)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* Help */.W, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "company.email.helpText",
                    defaultMessage: "Yrityksesi s\xe4hk\xf6postiosoite yhteydenottoja varten"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, CompanyBasicInfo_objectSpread({
                label: dictionary.homepage,
                variant: "outlined",
                fullWidth: true
            }, homepageField)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyEditSelect, {
                parentTitle: title,
                title: dictionary.languages,
                path: "languages",
                items: languages,
                onOpen: openSelect,
                onClose: closeSelect
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./hooks/useOnScreen.ts
var useOnScreen = __webpack_require__(36297);
;// CONCATENATED MODULE: ./components/company/CompanyMap/CompanyMap.tsx






function CompanyMap_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CompanyMap_templateObject() {
    var data = CompanyMap_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 50%;\n  max-height: 435.4px;\n\n  > div {\n    padding-top: 169.88%;\n  }\n\n  > svg,\n  > img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    CompanyMap_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var CompanyMap_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7d7c3054-0"
})(CompanyMap_templateObject());
var FakeMap = /*#__PURE__*/ (0,react.memo)(function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("img", {
        alt: "toimialueet kartalla",
        src: (0,utils/* imageFromCDN */.wg)('/emptyMap.svg'),
        width: 256.3,
        height: 435.4
    });
});
var CompanyMap = function(param1) {
    var operationalAreas = param1.operationalAreas;
    var containerRef = (0,react.useRef)(null);
    var isVisible = (0,useOnScreen/* useOnScreen */.R)(containerRef, {
        onlyOnce: true
    });
    // Import map only if required
    var CompanyMapContent1 = (0,react.useMemo)(function() {
        return isVisible ? (0,dynamic["default"])(function() {
            return __webpack_require__.e(/* import() */ 3542).then(__webpack_require__.bind(__webpack_require__, 63542)).then(function(param) {
                var CompanyMapContent = param.CompanyMapContent;
                return CompanyMapContent;
            });
        }, {
            loadableGenerated: {
                webpack: function() {
                    return [
                        /*require.resolve*/(63542)
                    ];
                }
            },
            loading: function() {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(FakeMap, {});
            }
        }) : FakeMap;
    }, [
        isVisible
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyMap_Container, {
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyMapContent1, {
                operationalAreas: operationalAreas
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/company/CompanyMap/index.ts


;// CONCATENATED MODULE: ./components/company/CompanyOperationInfo.tsx














function CompanyOperationInfo_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CompanyOperationInfo_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CompanyOperationInfo_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CompanyOperationInfo_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CompanyOperationInfo_templateObject() {
    var data = CompanyOperationInfo_taggedTemplateLiteral([
        "\n    margin-top: 1rem;\n    flex-direction: column;\n    align-items: center;\n\n    > div:last-of-type {\n      margin-top: 1rem;\n      margin-left: 0;\n    }\n  "
    ]);
    CompanyOperationInfo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyOperationInfo_templateObject1() {
    var data = CompanyOperationInfo_taggedTemplateLiteral([
        "\n  display: flex;\n\n  > div:first-of-type {\n    flex-shrink: 0;\n  }\n\n  > div:last-of-type {\n    flex: 1;\n    margin-left: 1rem;\n  }\n\n  ",
        "\n"
    ]);
    CompanyOperationInfo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var CompanyMapColumn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9e468d7f-0"
})(CompanyOperationInfo_templateObject1(), Theme/* mediaQuery.small */.cy.small((0,styled_components_browser_esm/* css */.iv)(CompanyOperationInfo_templateObject())));
var CompanyOperationInfo = function(param) {
    var company = param.company, editable = param.editable, premium = param.premium, loading = param.loading;
    var dictionary = (0,CompanyDictionary/* useCompanyDictionary */.F)();
    var isTalo80IDSelected = (0,advancedSearchStore/* useCheckSelectedID */.Tw)('talo80');
    var isTolIDSelected = (0,advancedSearchStore/* useCheckSelectedID */.Tw)('tol2008');
    var isContractingFormsIDSelected = (0,advancedSearchStore/* useCheckSelectedID */.Tw)('contractingForms');
    var isProjectTypesIDSelected = (0,advancedSearchStore/* useCheckSelectedID */.Tw)('projectTypes');
    var isOperationalAreasIDSelected = (0,advancedSearchStore/* useCheckSelectedID */.Tw)('operationalAreas');
    var isMachineryTypesIDSelected = (0,advancedSearchStore/* useCheckSelectedID */.Tw)('machineryTypes');
    var isTargetGroupsIDSelected = (0,advancedSearchStore/* useCheckSelectedID */.Tw)('targetGroups');
    var tol = company.tol, contractingForms = company.contractingForms, talo80 = company.talo80, operationalAreas = company.operationalAreas, projectTypes = company.projectTypes, machineryTypes = company.machineryTypes, customerTargetGroups = company.customerTargetGroups;
    var commonFieldProps = {
        premium: premium,
        loading: loading
    };
    var isPremiumLoading = premium && loading;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyGrid/* Grid */.rj, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyGrid/* Column */.sg, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Item */.ck, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Field */.gN, CompanyOperationInfo_objectSpread({
                            label: dictionary.talo80
                        }, commonFieldProps, {
                            chip: true,
                            empty: !talo80.length,
                            children: talo80.map(function(p, i) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Chip */.Af, {
                                    selected: isTalo80IDSelected(p.talo80ID),
                                    children: p.name
                                }, i);
                            })
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Item */.ck, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Field */.gN, CompanyOperationInfo_objectSpread({
                            label: dictionary.tol
                        }, commonFieldProps, {
                            chip: true,
                            empty: !(tol === null || tol === void 0 ? void 0 : tol.name),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Chip */.Af, {
                                selected: isTolIDSelected((tol === null || tol === void 0 ? void 0 : tol.tol2008ID) || 0),
                                children: (tol === null || tol === void 0 ? void 0 : tol.name) || ''
                            })
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Spacer */.LZ, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Item */.ck, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Field */.gN, CompanyOperationInfo_objectSpread({
                            label: dictionary.contractingForms
                        }, commonFieldProps, {
                            chip: true,
                            empty: !contractingForms.length,
                            children: contractingForms.map(function(p, i) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Chip */.Af, {
                                    selected: isContractingFormsIDSelected(p.contractingFormID),
                                    children: p.name
                                }, i);
                            })
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Item */.ck, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Field */.gN, CompanyOperationInfo_objectSpread({
                            label: dictionary.projectTypes
                        }, commonFieldProps, {
                            chip: true,
                            empty: !projectTypes.length,
                            children: projectTypes.map(function(p, i) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Chip */.Af, {
                                    selected: isProjectTypesIDSelected(p.projectTypeID),
                                    children: p.name
                                }, i);
                            })
                        }))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyGrid/* Column */.sg, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Item */.ck, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyMapColumn, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyMap, {
                                    operationalAreas: operationalAreas
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Field */.gN, CompanyOperationInfo_objectSpread({
                                    label: dictionary.operationalAreas
                                }, commonFieldProps, {
                                    chip: true,
                                    empty: !operationalAreas.length,
                                    children: operationalAreas.map(function(p, i) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Chip */.Af, {
                                            selected: isOperationalAreasIDSelected(p.areaID),
                                            children: p.name
                                        }, i);
                                    })
                                }))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Spacer */.LZ, {
                        show: isPremiumLoading || editable || !premium || machineryTypes.length
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Item */.ck, {
                        show: isPremiumLoading || editable || !premium || machineryTypes.length,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Field */.gN, CompanyOperationInfo_objectSpread({
                            label: dictionary.machineryTypes
                        }, commonFieldProps, {
                            chip: true,
                            empty: !machineryTypes.length,
                            children: machineryTypes.map(function(p, i) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Chip */.Af, {
                                    selected: isMachineryTypesIDSelected(p.machineryTypeID),
                                    children: p.name
                                }, i);
                            })
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Spacer */.LZ, {
                        show: isPremiumLoading || editable || !premium || customerTargetGroups.length
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Item */.ck, {
                        show: isPremiumLoading || editable || !premium || customerTargetGroups.length,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Field */.gN, CompanyOperationInfo_objectSpread({
                            label: dictionary.customerTargetGroups
                        }, commonFieldProps, {
                            chip: true,
                            empty: !customerTargetGroups.length,
                            children: customerTargetGroups.map(function(p, i) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Chip */.Af, {
                                    selected: isTargetGroupsIDSelected(p.targetGroupID),
                                    children: p.name
                                }, i);
                            })
                        }))
                    })
                ]
            })
        ]
    }));
};
var CompanyOperationInfoEdit = function(param) {
    var company = param.company, openSelect = param.openSelect, closeSelect = param.closeSelect;
    var intl = (0,useIntl/* default */.Z)();
    var title = intl.formatMessage({
        id: 'company.operationsTitle',
        defaultMessage: 'Toiminta'
    });
    var dictionary = (0,CompanyDictionary/* useCompanyDictionary */.F)();
    var ref = (0,state/* useScopedState */.S)(staticStore/* staticState */.G, [
        'talo80',
        'contractingForms',
        'projectTypes',
        'operationalAreas',
        'machineryTypes',
        'targetGroups', 
    ]), talo80 = ref.talo80, contractingForms = ref.contractingForms, projectTypes = ref.projectTypes, operationalAreas = ref.operationalAreas, machineryTypes = ref.machineryTypes, targetGroups = ref.targetGroups;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyEditSelect, {
                parentTitle: title,
                title: dictionary.talo80,
                path: "talo80",
                items: talo80,
                onOpen: openSelect,
                onClose: closeSelect
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* Help */.W, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "company.talo80.helpText",
                    defaultMessage: "Yrityksesi toimialaluokat Talo 80 nimikkeist\xf6j\xe4rjestelm\xe4st\xe4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyEditSelect, {
                parentTitle: title,
                title: dictionary.contractingForms,
                path: "contractingForms",
                items: contractingForms,
                onOpen: openSelect,
                onClose: closeSelect
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyEditSelect, {
                parentTitle: title,
                title: dictionary.projectTypes,
                path: "projectTypes",
                items: projectTypes,
                onOpen: openSelect,
                onClose: closeSelect
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyEditSelect, {
                parentTitle: title,
                title: dictionary.operationalAreas,
                path: "operationalAreas",
                items: operationalAreas,
                onOpen: openSelect,
                onClose: closeSelect
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* Help */.W, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "company.operationalAreas.helpText",
                    defaultMessage: "Alueet joilla yrityksesi on mahdolista toimia"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyEditSelect, {
                parentTitle: title,
                title: dictionary.machineryTypes,
                path: "machineryTypes",
                items: machineryTypes,
                onOpen: openSelect,
                onClose: closeSelect
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyEditSelect, {
                parentTitle: title,
                title: dictionary.customerTargetGroups,
                path: "customerTargetGroups",
                items: targetGroups,
                onOpen: openSelect,
                onClose: closeSelect
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(52795);
// EXTERNAL MODULE: ./node_modules/mdi-react/CheckDecagramIcon.js
var CheckDecagramIcon = __webpack_require__(42238);
var CheckDecagramIcon_default = /*#__PURE__*/__webpack_require__.n(CheckDecagramIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/InfoCircleIcon.js
var InfoCircleIcon = __webpack_require__(57956);
var InfoCircleIcon_default = /*#__PURE__*/__webpack_require__.n(InfoCircleIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/HelpIcon.js
var HelpIcon = __webpack_require__(95247);
var HelpIcon_default = /*#__PURE__*/__webpack_require__.n(HelpIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/WarningIcon.js
var WarningIcon = __webpack_require__(32529);
var WarningIcon_default = /*#__PURE__*/__webpack_require__.n(WarningIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/DangerousIcon.js
var DangerousIcon = __webpack_require__(87179);
var DangerousIcon_default = /*#__PURE__*/__webpack_require__.n(DangerousIcon);
// EXTERNAL MODULE: ./context/useUser.tsx
var useUser = __webpack_require__(95460);
;// CONCATENATED MODULE: ./components/company/CompanyTrustInfo.tsx

















function CompanyTrustInfo_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CompanyTrustInfo_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CompanyTrustInfo_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CompanyTrustInfo_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CompanyTrustInfo_templateObject() {
    var data = CompanyTrustInfo_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 0.6rem 0.7rem 0.5rem 0.7rem;\n  align-items: center;\n  text-align: center;\n  font-size: 0.875rem;\n  line-height: 1.4;\n\n  > svg {\n    position: absolute;\n    margin: 0 !important;\n    padding: 0.5rem;\n    top: -0.8rem;\n    right: -0.8rem;\n    background-color: ",
        ";\n    border-radius: 50%;\n    box-sizing: content-box;\n  }\n"
    ]);
    CompanyTrustInfo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var ReportTooltipStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f551cc7a-0"
})(CompanyTrustInfo_templateObject(), Theme/* Color.white */.Il.white);
var ReportTooltip = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(ReportTooltipStyle, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((DiamondIcon_default()), {
                color: Theme/* Color.primary */.Il.primary
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "company.trustInfo.reportUnauthorizedTooltip",
                defaultMessage: "Raportti on saatavilla Constle Pro -j\xe4senille"
            })
        ]
    });
};
var CompanyTrustInfo = function(param) {
    var company = param.company, premium = param.premium, loading = param.loading, trustInfo = param.trustInfo, isPremiumOverride = param.isPremiumOverride;
    var hasPremium = (0,useUser/* useUser */.a)().hasPremium;
    var ref = (0,react.useState)(false), reportTooltipOpen = ref[0], setReportTooltipOpen = ref[1];
    var commonFieldProps = {
        premium: premium,
        loading: loading
    };
    var preventReportDownload = !hasPremium && isPremiumOverride;
    var handleReportLinkClick = (0,react.useCallback)(function(event) {
        // Prevent download & show tooltip if company is in "preview" mode
        if (preventReportDownload) {
            event.preventDefault();
            setReportTooltipOpen(!reportTooltipOpen);
        }
    }, [
        preventReportDownload
    ]);
    var reportLink = /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        href: preventReportDownload ? '#' : "/api/v1/company/tilaajavastuu/pdf/".concat(company.businessID),
        download: true,
        onClick: handleReportLinkClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Lataa raportti"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((OpenInNewIcon_default()), {
                size: 18,
                color: Theme/* Color.disabled */.Il.disabled
            })
        ]
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyGrid/* Grid */.rj, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Column */.sg, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyGrid/* Grid */.rj, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Column */.sg, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Item */.ck, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Field */.gN, CompanyTrustInfo_objectSpread({
                                    label: 'Tila'
                                }, commonFieldProps, {
                                    large: true,
                                    premiumOnly: true,
                                    children: !premium || loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Skeleton */.Od, {
                                            loading: loading,
                                            width: "30%"
                                        })
                                    }) : trustInfo === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "-"
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: trustInfo.status !== 'not found' ? trustInfo.status : '-'
                                            }),
                                            trustInfo.status == 'Ok' && /*#__PURE__*/ (0,jsx_runtime.jsx)((CheckDecagramIcon_default()), {
                                                color: Theme/* Color.green */.Il.green
                                            }),
                                            trustInfo.status == 'Huomioi' && /*#__PURE__*/ (0,jsx_runtime.jsx)((InfoCircleIcon_default()), {
                                                color: "#44f"
                                            }),
                                            trustInfo.status == 'Tietoja odotetaan' && /*#__PURE__*/ (0,jsx_runtime.jsx)((HelpIcon_default()), {
                                                color: "#aaa"
                                            }),
                                            trustInfo.status == 'Selvit\xe4' && /*#__PURE__*/ (0,jsx_runtime.jsx)((WarningIcon_default()), {
                                                color: "#aa0"
                                            }),
                                            trustInfo.status == 'Seis' && /*#__PURE__*/ (0,jsx_runtime.jsx)((DangerousIcon_default()), {
                                                color: "#a00"
                                            })
                                        ]
                                    })
                                }))
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Column */.sg, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Item */.ck, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Field */.gN, CompanyTrustInfo_objectSpread({
                                    label: 'Tarkistettu'
                                }, commonFieldProps, {
                                    premiumOnly: true,
                                    children: !premium || loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Skeleton */.Od, {
                                        loading: loading,
                                        width: "50%"
                                    }) : new Date().toLocaleDateString('fi-fi')
                                }))
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Column */.sg, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Item */.ck, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Field */.gN, CompanyTrustInfo_objectSpread({
                        label: 'Raportti'
                    }, commonFieldProps, {
                        large: true,
                        premiumOnly: true,
                        children: !premium || loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Skeleton */.Od, {
                            loading: loading,
                            width: "80%"
                        }) : !trustInfo || trustInfo.status === 'not found' ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Raportti ei saatavilla"
                        }) : preventReportDownload ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
                            onClickAway: function() {
                                return setReportTooltipOpen(false);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                PopperProps: {
                                    disablePortal: true
                                },
                                onClose: function() {
                                    return setReportTooltipOpen(false);
                                },
                                open: reportTooltipOpen,
                                disableFocusListener: true,
                                disableHoverListener: true,
                                disableTouchListener: true,
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportTooltip, {}),
                                arrow: true,
                                children: reportLink
                            })
                        }) : reportLink
                    }))
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/company/CompanyCertificateInfo.tsx






function CompanyCertificateInfo_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CompanyCertificateInfo_templateObject() {
    var data = CompanyCertificateInfo_taggedTemplateLiteral([
        "\n  display: inline-block;\n  margin: 0px 8px;\n  vertical-align: -10%;\n  height: 16px;\n  width: 2px;\n  background-color: ",
        ";\n"
    ]);
    CompanyCertificateInfo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5774a641-0"
})(CompanyCertificateInfo_templateObject(), Theme/* Color.white */.Il.white);
var CompanyCertificateInfo = function(param) {
    var company = param.company, editable = param.editable, premium = param.premium, loading = param.loading;
    var taitoCompetences = company.taitoCompetences;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Grid */.rj, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Column */.sg, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Item */.ck, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Field */.gN, {
                    label: "Taitorekisteri",
                    loading: loading,
                    premium: premium,
                    premiumOnly: true,
                    chip: true,
                    empty: !taitoCompetences.length,
                    children: taitoCompetences.map(function(p, i) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(CompanyFieldAndHelpers/* Chip */.Af, {
                            children: [
                                p.name,
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    style: {
                                        margin: '0 4px 0 0'
                                    },
                                    children: p.totalAmountRange
                                }),
                                " hl\xf6"
                            ]
                        }, i);
                    })
                })
            })
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/mdi-react/TrendingDownIcon.js
var TrendingDownIcon = __webpack_require__(32337);
var TrendingDownIcon_default = /*#__PURE__*/__webpack_require__.n(TrendingDownIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/MinusIcon.js
var MinusIcon = __webpack_require__(10996);
var MinusIcon_default = /*#__PURE__*/__webpack_require__.n(MinusIcon);
;// CONCATENATED MODULE: ./components/company/FakeGraph.tsx



var FakeGraph = /*#__PURE__*/ (0,react.memo)(function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("img", {
        alt: "kaavio",
        src: (0,utils/* imageFromCDN */.wg)('/emptyLineGraph.svg'),
        width: 512.625,
        height: 280
    });
}, function() {
    return true;
});

;// CONCATENATED MODULE: ./components/company/LineGraph/LineGraph.tsx







function LineGraph_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function LineGraph_templateObject() {
    var data = LineGraph_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  height: 280px;\n\n  > div {\n    padding-top: 169.88%;\n  }\n\n  > svg,\n  > img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    overflow: visible;\n\n    .tick,\n    .domain {\n      color: ",
        ";\n    }\n\n    text {\n      color: ",
        ";\n    }\n  }\n\n  > img {\n    transform: translate(60, 10);\n    opacity: 0.05;\n  }\n"
    ]);
    LineGraph_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var LineGraph_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dcaa0204-0"
})(LineGraph_templateObject(), Theme/* Color.background */.Il.background, Theme/* Color.black */.Il.black);
var LineGraph = function(param1) {
    var data = param1.data, scale = param1.scale;
    var containerRef = (0,react.useRef)(null);
    var isVisible = (0,useOnScreen/* useOnScreen */.R)(containerRef, {
        onlyOnce: true
    });
    // Import graph only if required
    var LineGraphContent1 = (0,react.useMemo)(function() {
        return isVisible ? (0,dynamic["default"])(function() {
            return __webpack_require__.e(/* import() */ 7658).then(__webpack_require__.bind(__webpack_require__, 67658)).then(function(param) {
                var LineGraphContent = param.LineGraphContent;
                return LineGraphContent;
            });
        }, {
            loadableGenerated: {
                webpack: function() {
                    return [
                        /*require.resolve*/(67658)
                    ];
                }
            },
            loading: function() {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(FakeGraph, {});
            }
        }) : FakeGraph;
    }, [
        isVisible
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(LineGraph_Container, {
        ref: containerRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LineGraphContent1, {
            data: data,
            scale: scale
        })
    }));
};

;// CONCATENATED MODULE: ./components/company/LineGraph/index.ts


;// CONCATENATED MODULE: ./components/company/BarGraph/BarGraph.tsx







function BarGraph_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function BarGraph_templateObject() {
    var data = BarGraph_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  height: 280px;\n\n  > div {\n    padding-top: 169.88%;\n  }\n\n  > svg {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n\n    .tick,\n    .domain {\n      color: ",
        ";\n    }\n\n    text {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    BarGraph_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var BarGraph_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e4ac0e9-0"
})(BarGraph_templateObject(), Theme/* Color.background */.Il.background, Theme/* Color.black */.Il.black);
var BarGraph = function(param1) {
    var data = param1.data, scale = param1.scale, _formatTooltip = param1.formatTooltip, formatTooltip = _formatTooltip === void 0 ? null : _formatTooltip;
    var containerRef = (0,react.useRef)(null);
    var isVisible = (0,useOnScreen/* useOnScreen */.R)(containerRef, {
        onlyOnce: true
    });
    // Import graph only if required
    var BarGraphContent1 = (0,react.useMemo)(function() {
        return isVisible ? (0,dynamic["default"])(function() {
            return __webpack_require__.e(/* import() */ 9395).then(__webpack_require__.bind(__webpack_require__, 79395)).then(function(param) {
                var BarGraphContent = param.BarGraphContent;
                return BarGraphContent;
            });
        }, {
            loadableGenerated: {
                webpack: function() {
                    return [
                        /*require.resolve*/(79395)
                    ];
                }
            },
            loading: function() {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(FakeGraph, {});
            }
        }) : FakeGraph;
    }, [
        isVisible
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(BarGraph_Container, {
        ref: containerRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BarGraphContent1, {
            data: data,
            scale: scale
        })
    }));
};

;// CONCATENATED MODULE: ./components/company/BarGraph/index.ts


// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInDays/index.js
var differenceInDays = __webpack_require__(67803);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/getDayOfYear/index.js + 1 modules
var getDayOfYear = __webpack_require__(36771);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/getYear/index.js
var getYear = __webpack_require__(95570);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isBefore/index.js
var isBefore = __webpack_require__(313);
;// CONCATENATED MODULE: ./components/company/useFinancialData.ts


function useFinancialData_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useFinancialData_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return useFinancialData_arrayLikeToArray(arr);
}
function useFinancialData_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useFinancialData_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function useFinancialData_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useFinancialData_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useFinancialData_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function useFinancialData_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = useFinancialData_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function useFinancialData_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function useFinancialData_toConsumableArray(arr) {
    return useFinancialData_arrayWithoutHoles(arr) || useFinancialData_iterableToArray(arr) || useFinancialData_unsupportedIterableToArray(arr) || useFinancialData_nonIterableSpread();
}
function useFinancialData_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useFinancialData_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useFinancialData_arrayLikeToArray(o, minLen);
}
/** Get the year that the majority of a date range falls on */ var caluclateMajorityYear = function(a, b) {
    var start = (0,parseISO/* default */.Z)(a);
    var end = (0,parseISO/* default */.Z)(b);
    var durationInDays = (0,differenceInDays/* default */.Z)(end, start);
    var excessDaysInOneYearPeriod = Math.max(0, durationInDays - 365);
    // We MUST ignore everything that goes over 365 days here, because it
    // would mest up the calculations below. If the accounting period crosses
    // the 365 day line, it will be a "special extension" period anyway, so
    // it "should not" affect any calculations...
    var endDayOfYear = (0,getDayOfYear/* default */.Z)(end) - excessDaysInOneYearPeriod;
    var halfOfDurationInDays = Math.floor(Math.min(durationInDays, 365) / 2);
    // If half of the duration is larger than the (day of year) the period ended on,
    // most of the prediod MUST land on the year the period started on
    if (halfOfDurationInDays > endDayOfYear) {
        return (0,getYear/* default */.Z)(start);
    } else {
        return (0,getYear/* default */.Z)(end);
    }
};
var calculateAccountingPeriods = function(financials) {
    // Safeguard for invalid financial data
    if (!financials || !financials.length) return [];
    // Order the financial data by date
    var orderedFinancials = useFinancialData_toConsumableArray(financials).sort(function(a, b) {
        return (0,isBefore/* default */.Z)((0,parseISO/* default */.Z)(a.accountingPeriodEnd), (0,parseISO/* default */.Z)(b.accountingPeriodEnd)) ? 1 : -1;
    });
    // Get the year for the latest period
    var latestPediod = orderedFinancials[0];
    var latestPeriodYear = caluclateMajorityYear(latestPediod.accountingPeriodStart, latestPediod.accountingPeriodEnd);
    // Every period after the first will be in sequential year order
    // TODO: Can an accounting period ever skip a year?
    var processedFinancialData = orderedFinancials.map(function(_param, index) {
        var accountingPeriodStart = _param.accountingPeriodStart, accountingPeriodEnd = _param.accountingPeriodEnd, rest = useFinancialData_objectWithoutProperties(_param, [
            "accountingPeriodStart",
            "accountingPeriodEnd"
        ]);
        return useFinancialData_objectSpread({}, rest, {
            year: latestPeriodYear - index
        });
    });
    return processedFinancialData;
};
var calculateAbsoluteScale = function(low, high) {
    var padding = high * 0.2;
    return [
        0,
        high + padding
    ];
};
var calculateRelativeScale = function(low, high) {
    var padding = (high - low) * 0.2;
    return [
        low - padding,
        high + padding
    ];
};
/** Calculate scale values (high & low) for a graph */ var calculateScale = function(points) {
    var _Math, _Math1;
    var low = (_Math = Math).min.apply(_Math, useFinancialData_toConsumableArray(points));
    var high = (_Math1 = Math).max.apply(_Math1, useFinancialData_toConsumableArray(points));
    // Only render with absolute scale (0 - hight) if graph is diverse enough
    var isAbsolutePossible = Math.abs((high - low) / low) > 0.2 && low > 0;
    if (isAbsolutePossible) return calculateAbsoluteScale(low, high);
    return calculateRelativeScale(low, high);
};
var useFinancialData = function(company) {
    var financials = (0,react.useMemo)(function() {
        return calculateAccountingPeriods(company.financials);
    }, [
        company.financials
    ]);
    var turnover1 = (0,react.useMemo)(function() {
        var turnoverData = financials.map(function(param) {
            var year = param.year, turnover = param.turnover;
            return {
                year: year,
                value: turnover
            };
        });
        var turnoverChange = financials[0].turnoverChangePercentage || 0;
        var turnoverScale = calculateScale(turnoverData.map(function(param) {
            var value = param.value;
            return value;
        }));
        return {
            turnoverData: turnoverData,
            turnoverChange: turnoverChange,
            turnoverScale: turnoverScale
        };
    }, [
        financials
    ]);
    var operating = (0,react.useMemo)(function() {
        var operatingData = financials.map(function(param) {
            var year = param.year, operatingResultPercentage = param.operatingResultPercentage, turnover = param.turnover;
            return {
                year: year,
                value: Math.round(operatingResultPercentage * turnover / 100000) * 1000
            };
        });
        var operatingChange = 0;
        if (financials.length >= 2) {
            var one = operatingData[1].value;
            var two = operatingData[0].value;
            operatingChange = (two - one) / Math.abs(one) * 100;
        }
        var operatingScale = calculateScale(operatingData.map(function(param) {
            var value = param.value;
            return value;
        }));
        return {
            operatingData: operatingData,
            operatingChange: operatingChange,
            operatingScale: operatingScale
        };
    }, [
        financials
    ]);
    var equity = (0,react.useMemo)(function() {
        var equityData = financials.map(function(param) {
            var year = param.year, equityRatio = param.equityRatio;
            return {
                year: year,
                value: equityRatio
            };
        });
        var equityChange = 0;
        if (financials.length >= 2) {
            var one = equityData[1].value;
            var two = equityData[0].value;
            equityChange = (two - one) * 100;
        }
        return {
            equityData: equityData,
            equityChange: equityChange
        };
    }, [
        financials
    ]);
    var employee = (0,react.useMemo)(function() {
        var employeeData = financials.map(function(param) {
            var year = param.year, numberOfEmployees = param.numberOfEmployees;
            return {
                year: year,
                value: numberOfEmployees
            };
        });
        var employeeChange = 0;
        if (financials.length >= 2) {
            var one = employeeData[1].value;
            var two = employeeData[0].value;
            employeeChange = (two - one) / Math.abs(one) * 100;
        }
        return {
            employeeData: employeeData,
            employeeChange: employeeChange
        };
    }, [
        financials
    ]);
    return useFinancialData_objectSpread({}, turnover1, operating, equity, employee);
};

;// CONCATENATED MODULE: ./components/company/CompanyFinanceInfo.tsx













function CompanyFinanceInfo_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CompanyFinanceInfo_templateObject() {
    var data = CompanyFinanceInfo_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n"
    ]);
    CompanyFinanceInfo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyFinanceInfo_templateObject1() {
    var data = CompanyFinanceInfo_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  color: ",
        ";\n\n  svg {\n    opacity: 0.7;\n  }\n\n  b {\n    // font-weight: 500;\n\n    // hide % if not finite value\n    ",
        "\n  }\n"
    ]);
    CompanyFinanceInfo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var State = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-85e1485a-0"
})(CompanyFinanceInfo_templateObject());
var Trend = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-85e1485a-1"
})(CompanyFinanceInfo_templateObject1(), function(param) {
    var color = param.color;
    return color;
}, function(param) {
    var notFinite = param.notFinite;
    return notFinite ? "" : "\n        &:after {\n          content: '%';\n          font-size: 1.2rem;\n          opacity: 0.7;\n        }\n        ";
});
var TrendingValue = function(param) {
    var value = param.value, _size = param.size, size = _size === void 0 ? 28 : _size;
    var color = (0,react.useMemo)(function() {
        if (value > 0) return Theme/* Color.green */.Il.green;
        if (value < 0) return Theme/* Color.red */.Il.red;
        return Theme/* Color.disabled */.Il.disabled;
    }, []);
    var icon = (0,react.useMemo)(function() {
        if (value > 0) return(/*#__PURE__*/ (0,jsx_runtime.jsx)((TrendingUpIcon_default()), {}));
        if (value < 0) return(/*#__PURE__*/ (0,jsx_runtime.jsx)((TrendingDownIcon_default()), {}));
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)((MinusIcon_default()), {}));
    }, [
        value
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Trend, {
        color: color,
        notFinite: !isFinite(value),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon.type, {
                size: size
            }),
            ' ',
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                children: [
                    value > 0 && '+',
                    (value === 0 || isNaN(value)) && '\xb1',
                    value ? isFinite(value) ? (0,utils/* formatNumber */.uf)(parseFloat(value.toFixed(1))) : '' : 0
                ]
            })
        ]
    }));
};
var CompanyFinanceInfo = function(param) {
    var company = param.company, premium = param.premium, loading = param.loading;
    var ref = useFinancialData(company), turnoverData = ref.turnoverData, turnoverChange = ref.turnoverChange, turnoverScale = ref.turnoverScale, operatingData = ref.operatingData, operatingChange = ref.operatingChange, operatingScale = ref.operatingScale, equityData = ref.equityData, equityChange = ref.equityChange, employeeData = ref.employeeData, employeeChange = ref.employeeChange;
    var formatEquityTooltip = (0,react.useCallback)(function(value) {
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                (0,utils/* formatNumber */.uf)(value * 100),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        fontSize: '0.75em',
                        opacity: 0.5
                    },
                    children: "%"
                })
            ]
        });
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyGrid/* Grid */.rj, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyGrid/* Column */.sg, {
                children: [
                    !!turnoverData.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyGrid/* Item */.ck, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Field */.gN, {
                                label: "Liikevaihto",
                                empty: !turnoverData.length,
                                large: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(State, {
                                    children: [
                                        (0,utils/* formatNumber */.uf)(turnoverData[0].value),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingValue, {
                                            value: turnoverChange
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LineGraph, {
                                data: turnoverData,
                                scale: turnoverScale
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Spacer */.LZ, {}),
                    !!equityData.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyGrid/* Item */.ck, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Field */.gN, {
                                label: "Omavaraisuus",
                                empty: !equityData.length,
                                large: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(State, {
                                    children: [
                                        (equityData[0].value * 100).toFixed(0),
                                        " %",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingValue, {
                                            value: equityChange
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BarGraph, {
                                data: equityData,
                                scale: [
                                    0,
                                    1
                                ],
                                formatTooltip: formatEquityTooltip
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyGrid/* Column */.sg, {
                children: [
                    !!operatingData.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyGrid/* Item */.ck, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Field */.gN, {
                                label: "Liikevoitto",
                                empty: !operatingData.length,
                                large: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(State, {
                                    children: [
                                        (0,utils/* formatNumber */.uf)(operatingData[0].value),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingValue, {
                                            value: operatingChange
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LineGraph, {
                                data: operatingData,
                                scale: operatingScale
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Spacer */.LZ, {}),
                    !!employeeData.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyGrid/* Item */.ck, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* Field */.gN, {
                                label: "Henkil\xf6st\xf6",
                                empty: !employeeData.length,
                                large: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(State, {
                                    children: [
                                        (0,utils/* formatNumber */.uf)(employeeData[0].value),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingValue, {
                                            value: employeeChange
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BarGraph, {
                                data: employeeData
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./components/Error.tsx
var Error = __webpack_require__(89649);
// EXTERNAL MODULE: ./components/common/StyledDialog.tsx
var StyledDialog = __webpack_require__(70904);
// EXTERNAL MODULE: ./context/basicErrorHandling.tsx
var basicErrorHandling = __webpack_require__(49219);
// EXTERNAL MODULE: ./lib/ga.ts
var ga = __webpack_require__(5590);
;// CONCATENATED MODULE: ./components/company/CompanyEditDialog.tsx














function CompanyEditDialog_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function CompanyEditDialog_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                CompanyEditDialog_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                CompanyEditDialog_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function CompanyEditDialog_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CompanyEditDialog_templateObject() {
    var data = CompanyEditDialog_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n\n  > .MuiFormControl-root {\n    margin-top: 2rem;\n  }\n\n  > button {\n    margin-top: 1.2rem;\n  }\n\n  @media (max-width: 640px) {\n    flex: 1;\n  }\n"
    ]);
    CompanyEditDialog_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyEditDialog_templateObject1() {
    var data = CompanyEditDialog_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n\n  @media (max-width: 640px) {\n    flex: 1;\n  }\n"
    ]);
    CompanyEditDialog_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompanyEditDialog_templateObject2() {
    var data = CompanyEditDialog_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 1rem;\n"
    ]);
    CompanyEditDialog_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var CompanyEditDialog_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d52c1ab5-0"
})(CompanyEditDialog_templateObject());
var Select = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d52c1ab5-1"
})(CompanyEditDialog_templateObject1());
var Control = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d52c1ab5-2"
})(CompanyEditDialog_templateObject2());
var CompanyEditDialog = function(param) {
    var open = param.open, company = param.company, ContentComponent = param.content, onUpdate = param.onUpdate, onClose = param.onClose;
    var ref7 = (0,state/* useScopedState */.S)(companyEditState), set = ref7.set, doGetEditRequestPayload = ref7.doGetEditRequestPayload;
    var ref1 = (0,react.useState)(null), selectComponent = ref1[0], setSelectComponent = ref1[1];
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react.useState)(null), error = ref3[0], setError = ref3[1];
    var ref4 = (0,react.useState)(null), control = ref4[0], setControl = ref4[1];
    var ref5 = (0,react.useState)(false), disabled1 = ref5[0], setDisabled = ref5[1];
    var intl = (0,useIntl/* default */.Z)();
    /** Convert latest company data to editable form when the dialog is opened */ (0,react.useEffect)(function() {
        if (open) {
            set(convertEditableToState(convertCompanyDocumentToEditable(company)));
            setControl(null);
            setDisabled(null);
            setError(null);
            setLoading(null);
        }
    }, [
        open
    ]);
    /** Collect edited data and send the API request */ var handleEdit = function() {
        var _ref = CompanyEditDialog_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, status, payload, ref6, status1, updatedDocument, errorStatus;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setLoading(true);
                        setError(null);
                        _ctx.next = 5;
                        return doGetEditRequestPayload({
                            company: company
                        });
                    case 5:
                        ref = _ctx.sent;
                        status = ref.status;
                        payload = ref.payload;
                        // Something was changed, send the API request
                        (0,ga/* gaEvent */.j)('edit_company', {
                            event_category: 'engagement',
                            event_label: 'save'
                        });
                        if (!(status !== 'nothing changed')) {
                            _ctx.next = 22;
                            break;
                        }
                        _ctx.next = 12;
                        return (0,utils/* nextApiRequest */.Qd)('/api/v1/www/company/edit', payload);
                    case 12:
                        ref6 = _ctx.sent;
                        status1 = ref6.status;
                        updatedDocument = ref6.company;
                        errorStatus = (0,basicErrorHandling/* handleBasicErrors */.i)({
                            status: status1,
                            catchAll: true
                        });
                        if (!errorStatus) {
                            _ctx.next = 18;
                            break;
                        }
                        return _ctx.abrupt("return", setError(errorStatus.error));
                    case 18:
                        // Update the loaded company document after it has been saved
                        onUpdate(updatedDocument);
                        onClose();
                        _ctx.next = 23;
                        break;
                    case 22:
                        {
                            onClose();
                        }
                    case 23:
                        _ctx.next = 29;
                        break;
                    case 25:
                        _ctx.prev = 25;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                        setError(/*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "unknownError",
                            defaultMessage: "Jokin meni vikaan, yrit\xe4 my\xf6hemmin uudelleen…"
                        }));
                    case 29:
                        _ctx.prev = 29;
                        setLoading(false);
                        return _ctx.finish(29);
                    case 32:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    25,
                    29,
                    32
                ]
            ]);
        }));
        return function handleEdit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handlePreviousClick = function() {
        var _ref = CompanyEditDialog_asyncToGenerator(runtime_default().mark(function _callee() {
            var status, confirmText;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!selectComponent) {
                            _ctx.next = 4;
                            break;
                        }
                        {
                            handleSelectClose();
                        }
                        _ctx.next = 8;
                        break;
                    case 4:
                        _ctx.next = 6;
                        return doGetEditRequestPayload({
                            company: company
                        });
                    case 6:
                        status = _ctx.sent.status;
                        if (status !== 'nothing changed') {
                            confirmText = intl.formatMessage({
                                id: 'company.editDialog.confirmExitText',
                                defaultMessage: 'Sinulla on tallentamattomia muutoksia. Oletko varma ett\xe4 haluat lopettaa muokkaamisen ilman tallennusta?'
                            });
                            if (window.confirm(confirmText)) {
                                onClose();
                            }
                        } else {
                            onClose();
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handlePreviousClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSaveClick = function() {
        if (!!selectComponent) {
            handleSelectClose();
        } else {
            handleEdit().catch(console.error);
        }
    };
    var handleSelectOpen = function(component) {
        setSelectComponent(component);
    };
    var handleSelectClose = function() {
        setSelectComponent(null);
    };
    var handleSaveDisable = function(disabled) {
        setDisabled(disabled);
    };
    var handleControlSet = function(component) {
        setControl(component);
    };
    var handleClose = function(_, reason) {
        if (reason === 'backdropClick') return;
        if (onClose) onClose();
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDialog/* StyledDialog */.I, {
        open: open,
        onClose: handleClose,
        "aria-labelledby": "simple-modal-title",
        "aria-describedby": "simple-modal-description",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDialog/* Dialog */.V, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyEditDialog_Content, {
                    style: {
                        display: selectComponent ? 'none' : 'flex'
                    },
                    children: ContentComponent && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentComponent, {
                        company: company,
                        openSelect: handleSelectOpen,
                        closeSelect: handleSelectClose,
                        disableSave: handleSaveDisable,
                        setControl: handleControlSet,
                        setError: setError,
                        close: handlePreviousClick,
                        save: handleEdit
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Select, {
                    style: {
                        display: !selectComponent ? 'none' : 'flex'
                    },
                    children: selectComponent
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Error/* Error */.j, {
                    error: error
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Control, {
                    children: [
                        control,
                        !control && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* Button */.z, {
                                    variant: "text",
                                    color: "default",
                                    disabled: loading,
                                    onClick: handlePreviousClick,
                                    children: !!selectComponent ? 'Takaisin' : 'Sulje'
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* Button */.z, {
                                    loading: loading || disabled1,
                                    onClick: handleSaveClick,
                                    children: !!selectComponent ? 'OK' : 'Tallenna'
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./context/paywallStore.tsx
var paywallStore = __webpack_require__(90588);
// EXTERNAL MODULE: ./components/company/useCompanyActions.tsx
var useCompanyActions = __webpack_require__(95804);
// EXTERNAL MODULE: ./components/company/useCompanyActionMenu.tsx
var useCompanyActionMenu = __webpack_require__(6769);
// EXTERNAL MODULE: ./components/company-list/CompanyListRow.tsx
var CompanyListRow = __webpack_require__(51453);
// EXTERNAL MODULE: ./node_modules/mdi-react/ClipboardTextIcon.js
var ClipboardTextIcon = __webpack_require__(13433);
var ClipboardTextIcon_default = /*#__PURE__*/__webpack_require__.n(ClipboardTextIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/ClipboardTextOutlineIcon.js
var ClipboardTextOutlineIcon = __webpack_require__(65391);
var ClipboardTextOutlineIcon_default = /*#__PURE__*/__webpack_require__.n(ClipboardTextOutlineIcon);
// EXTERNAL MODULE: ./components/SEO.tsx
var SEO = __webpack_require__(81476);
// EXTERNAL MODULE: ./common/Constants.ts
var Constants = __webpack_require__(72916);
// EXTERNAL MODULE: ./components/omnibar/OmnibarPremiumBanner.tsx
var OmnibarPremiumBanner = __webpack_require__(72685);
// EXTERNAL MODULE: ./lib/companyHistory.ts
var companyHistory = __webpack_require__(26299);
// EXTERNAL MODULE: ./node_modules/mdi-react/MedalIcon.js
var MedalIcon = __webpack_require__(91791);
var MedalIcon_default = /*#__PURE__*/__webpack_require__.n(MedalIcon);
;// CONCATENATED MODULE: ./components/company/EditReference.tsx
















function EditReference_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function EditReference_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return EditReference_arrayLikeToArray(arr);
}
function EditReference_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function EditReference_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function EditReference_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function EditReference_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            EditReference_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function EditReference_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = EditReference_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function EditReference_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function EditReference_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function EditReference_toConsumableArray(arr) {
    return EditReference_arrayWithoutHoles(arr) || EditReference_iterableToArray(arr) || EditReference_unsupportedIterableToArray(arr) || EditReference_nonIterableSpread();
}
function EditReference_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return EditReference_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return EditReference_arrayLikeToArray(o, minLen);
}
function EditReference_templateObject() {
    var data = EditReference_taggedTemplateLiteral([
        "\n  overflow-y: auto;\n\n  .MuiFormControl-root {\n    margin-top: 1rem;\n    margin-bottom: 0.5rem;\n  }\n"
    ]);
    EditReference_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var EditReference_Form = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4407df7d-0"
})(EditReference_templateObject());
var EditReferenceItem = function(_param) /*#__PURE__*/ {
    var _reference = _param.reference, referenceID = _reference.referenceID, customer = _reference.customer, value = _reference.value, date = _reference.date, isHidden = _reference.isHidden, actions = EditReference_objectWithoutProperties(_param, [
        "reference"
    ]);
    return (0,jsx_runtime.jsx)("div", {
        style: {
            opacity: isHidden ? 0.55 : 1
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditListItem, EditReference_objectSpread({
            id: referenceID,
            title: customer,
            subtitle: [
                value,
                date
            ].filter(function(property) {
                return !!property;
            }).join(', '),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((MedalIcon_default()), {})
        }, actions, {
            isHidden: isHidden
        }))
    });
};

var EditReferenceView = function(param) {
    var referenceID = param.referenceID, parentTitle = param.parentTitle, onClose = param.onClose;
    var dictionary = (0,CompanyDictionary/* useCompanyDictionary */.F)();
    var ref = (0,state/* useScopedState */.S)(companyEditState, [
        'references'
    ]), references1 = ref.references, set = ref.set;
    var reference = references1.find(function(item) {
        return item.referenceID === referenceID;
    });
    var handleChange = (0,react.useCallback)(function(field, event) {
        var references = companyEditState.getState().references;
        var updatedReferences = EditReference_toConsumableArray(references);
        var index = updatedReferences.findIndex(function(item) {
            return item.referenceID === referenceID;
        });
        updatedReferences[index][field] = event.target.value;
        set({
            references: updatedReferences
        });
    }, [
        referenceID,
        set
    ]);
    var handleDescriptionChange = (0,react.useCallback)(function(event) {
        return handleChange('description', event);
    }, [
        handleChange
    ]);
    var handleValueChange = (0,react.useCallback)(function(event) {
        return handleChange('value', event);
    }, [
        handleChange
    ]);
    var handleDateChange = (0,react.useCallback)(function(event) {
        return handleChange('date', event);
    }, [
        handleChange
    ]);
    var handleCustomerChange = (0,react.useCallback)(function(event) {
        return handleChange('customer', event);
    }, [
        handleChange
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    color: "primary",
                    startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowLeftIcon_default()), {
                        size: 16,
                        color: Theme/* Color.primary */.Il.primary
                    }),
                    size: "small",
                    onClick: onClose,
                    children: parentTitle
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "company.reference",
                    defaultMessage: "Referenssi"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EditReference_Form, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        label: dictionary.referencesDescription,
                        variant: "outlined",
                        fullWidth: true,
                        multiline: true,
                        value: reference.description,
                        onChange: handleDescriptionChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        label: dictionary.referencesValue,
                        variant: "outlined",
                        fullWidth: true,
                        value: reference.value,
                        onChange: handleValueChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        label: dictionary.referencesDate,
                        variant: "outlined",
                        fullWidth: true,
                        value: reference.date,
                        onChange: handleDateChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        label: dictionary.referencesCustomer,
                        variant: "outlined",
                        fullWidth: true,
                        value: reference.customer,
                        onChange: handleCustomerChange
                    })
                ]
            })
        ]
    }));
};
var EditReference = function(param1) {
    var parentTitle = param1.parentTitle, onOpen = param1.onOpen, onClose = param1.onClose;
    var intl = (0,useIntl/* default */.Z)();
    var removeConfirmationText = intl.formatMessage({
        id: 'company.reference.edit.removeConfirmationText',
        defaultMessage: 'Oletko varma ett\xe4 haluat poistaa referenssin?'
    });
    var ref = (0,state/* useScopedState */.S)(companyEditState, [
        'references'
    ]), references = ref.references, set = ref.set;
    var setList = (0,react.useCallback)(function(list) {
        return set({
            references: list
        });
    }, [
        set
    ]);
    var ref1 = useEditList({
        list: references,
        keyColumn: 'referenceID',
        removeConfirmationText: removeConfirmationText,
        emptyItem: {
            referenceID: 0,
            description: '',
            value: '',
            date: '',
            customer: '',
            isHidden: false,
            isDeleted: false
        },
        setList: setList
    }), move = ref1.move, remove = ref1.remove, create = ref1.create;
    /** Render the actual edit view, will be called by the edit dialog when requested */ var renderEditComponent = (0,react.useCallback)(function(referenceID) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(EditReferenceView, {
            referenceID: referenceID,
            parentTitle: parentTitle,
            onClose: onClose
        });
    }, [
        parentTitle,
        onClose
    ]);
    var handleEdit = (0,react.useCallback)(function(referenceID) {
        onOpen(renderEditComponent(referenceID));
    }, [
        renderEditComponent,
        onOpen
    ]);
    var handleCreate = (0,react.useCallback)(function() {
        var referenceID = create().referenceID;
        onOpen(renderEditComponent(referenceID));
    }, [
        create,
        renderEditComponent,
        onOpen
    ]);
    var renderLocation = (0,react.useCallback)(function(reference) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(EditReferenceItem, {
            reference: reference,
            onMove: move,
            onEdit: handleEdit,
            onRemove: remove
        }, reference.referenceID);
    }, [
        move,
        remove,
        handleEdit
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* default */.Z, {
            disablePadding: true,
            children: [
                references.filter(function(param) {
                    var isDeleted = param.isDeleted;
                    return !isDeleted;
                }).map(renderLocation),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EditListCreateButton, {
                    onClick: handleCreate
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/company/CompanyReferenceEdit.tsx








function CompanyReferenceEdit_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CompanyReferenceEdit_templateObject() {
    var data = CompanyReferenceEdit_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-wrap: wrap;\n\n    .MuiTypography-h5 {\n      font-size: 1.5rem;\n    }\n\n    p {\n      margin: 0.2rem 0;\n      white-space: pre-line;\n    }\n  "
    ]);
    CompanyReferenceEdit_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyReferenceEdit_templateObject1() {
    var data = CompanyReferenceEdit_taggedTemplateLiteral([
        "\n      width: 50%;\n    "
    ]);
    CompanyReferenceEdit_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompanyReferenceEdit_templateObject2() {
    var data = CompanyReferenceEdit_taggedTemplateLiteral([
        "\n      width: 100%;\n    "
    ]);
    CompanyReferenceEdit_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CompanyReferenceEdit_templateObject3() {
    var data = CompanyReferenceEdit_taggedTemplateLiteral([
        "\n    display: flex;\n    margin-top: 1rem;\n    width: 33.33%;\n\n    > div:last-child {\n      flex: 1;\n      margin-left: 1rem;\n\n      p {\n        display: flex;\n        align-items: center;\n\n        &:first-of-type {\n          margin-bottom: 0.4rem;\n        }\n\n        svg {\n          margin-right: 0.6rem;\n          width: 16px;\n          height: 16px;\n          opacity: 0.5;\n        }\n      }\n    }\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    CompanyReferenceEdit_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CompanyReferenceEdit_templateObject4() {
    var data = CompanyReferenceEdit_taggedTemplateLiteral([
        "\n      width: 50%;\n    "
    ]);
    CompanyReferenceEdit_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CompanyReferenceEdit_templateObject5() {
    var data = CompanyReferenceEdit_taggedTemplateLiteral([
        "\n      width: 100%;\n    "
    ]);
    CompanyReferenceEdit_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function CompanyReferenceEdit_templateObject6() {
    var data = CompanyReferenceEdit_taggedTemplateLiteral([
        "\n    display: flex;\n    margin-top: 1rem;\n    width: 33.33%;\n\n    > div:last-child {\n      flex: 1;\n      margin-left: 1rem;\n\n      p {\n        display: flex;\n        align-items: center;\n\n        &:first-of-type {\n          margin-bottom: 0.4rem;\n        }\n\n        svg {\n          margin-right: 0.6rem;\n          width: 16px;\n          height: 16px;\n          opacity: 0.5;\n        }\n      }\n    }\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    CompanyReferenceEdit_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function CompanyReferenceEdit_templateObject7() {
    var data = CompanyReferenceEdit_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-shrink: 0;\n    align-items: center;\n    justify-content: center;\n    width: 64px;\n    height: 64px;\n    border-radius: 50%;\n    background-color: ",
        ";\n\n    svg {\n      color: ",
        ";\n    }\n  "
    ]);
    CompanyReferenceEdit_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function CompanyReferenceEdit_templateObject8() {
    var data = CompanyReferenceEdit_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n\n  > div {\n    margin-top: 1rem;\n    margin-bottom: 0.5rem;\n  }\n\n  > button {\n    margin-bottom: 0.5rem;\n  }\n"
    ]);
    CompanyReferenceEdit_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
var CompanyReferenceEdit_Styled = {
    Row: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-37b94413-0"
    })(CompanyReferenceEdit_templateObject()),
    Address: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-37b94413-1"
    })(CompanyReferenceEdit_templateObject3(), Theme/* mediaQuery.medium */.cy.medium((0,styled_components_browser_esm/* css */.iv)(CompanyReferenceEdit_templateObject1())), Theme/* mediaQuery.small */.cy.small((0,styled_components_browser_esm/* css */.iv)(CompanyReferenceEdit_templateObject2()))),
    Contact: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-37b94413-2"
    })(CompanyReferenceEdit_templateObject6(), Theme/* mediaQuery.medium */.cy.medium((0,styled_components_browser_esm/* css */.iv)(CompanyReferenceEdit_templateObject4())), Theme/* mediaQuery.small */.cy.small((0,styled_components_browser_esm/* css */.iv)(CompanyReferenceEdit_templateObject5()))),
    Image: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-37b94413-3"
    })(CompanyReferenceEdit_templateObject7(), Theme/* Color.background */.Il.background, Theme/* Color.disabled */.Il.disabled)
};
var CompanyReferenceEdit_EditContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-37b94413-4"
})(CompanyReferenceEdit_templateObject8());
var CompanyReferenceEdit = function(param) {
    var company = param.company, openSelect = param.openSelect, closeSelect = param.closeSelect;
    var dictionary = (0,CompanyDictionary/* useCompanyDictionary */.F)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                children: dictionary.references
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyReferenceEdit_EditContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldAndHelpers/* StyledLabel */.ar, {
                        children: dictionary.references
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EditReference, {
                        parentTitle: dictionary.references,
                        onOpen: openSelect,
                        onClose: closeSelect
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/company/CompanyReferenceInfo.tsx






function CompanyReferenceInfo_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CompanyReferenceInfo_templateObject() {
    var data = CompanyReferenceInfo_taggedTemplateLiteral([
        "\n  min-height: 30.7px; // This is to make the height of the quote column the same as the turnover column\n  white-space: pre;\n  white-space: pre-wrap; /* css-3 */\n  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */\n  white-space: -pre-wrap; /* Opera 4-6 */\n  white-space: -o-pre-wrap; /* Opera 7 */\n  word-wrap: break-word;\n\n  word-break: break-all;\n  word-break: break-word;\n"
    ]);
    CompanyReferenceInfo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyReferenceInfo_templateObject1() {
    var data = CompanyReferenceInfo_taggedTemplateLiteral([
        "\n  position: relative;\n\n  &::before {\n    content: '';\n    position: absolute;\n    display: block;\n    bottom: -2.2rem;\n    left: 50%;\n    width: 100%;\n    height: 2px;\n    background-color: #f0f0f0;\n    transform: translateX(-50%);\n  }\n\n  > div:last-of-type {\n    display: flex;\n    flex-direction: column;\n    margin-top: 4px;\n\n    span {\n      display: flex;\n    }\n\n    b {\n      display: block;\n      width: 100px;\n      color: #222222;\n    }\n  }\n"
    ]);
    CompanyReferenceInfo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompanyReferenceInfo_templateObject2() {
    var data = CompanyReferenceInfo_taggedTemplateLiteral([
        "\n    padding: 1.2rem 2rem 2rem 2rem;\n\n    &::before {\n      display: none;\n    }\n\n    > article {\n      width: 100%;\n    }\n  "
    ]);
    CompanyReferenceInfo_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CompanyReferenceInfo_templateObject3() {
    var data = CompanyReferenceInfo_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4.4rem;\n  padding: 1.2rem 3.2rem 2rem 3.2rem;\n\n  &::before {\n    content: '';\n    position: absolute;\n    display: block;\n    top: 0;\n    left: 50%;\n    width: 2px;\n    height: calc(100% - 2rem);\n    background-color: #f0f0f0;\n    transform: translateX(-50%);\n  }\n\n  > article {\n    width: calc(50% - 2.2rem);\n  }\n\n  ",
        "\n"
    ]);
    CompanyReferenceInfo_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var CompanyReferenceInfo_LargeQuote = (0,styled_components_browser_esm/* default */.ZP)(CompanyFieldAndHelpers/* Quote */.pu).withConfig({
    componentId: "sc-3a1539c9-0"
})(CompanyReferenceInfo_templateObject());
var References = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    componentId: "sc-3a1539c9-1"
})(CompanyReferenceInfo_templateObject1());
var CompanyReferenceInfo_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3a1539c9-2"
})(CompanyReferenceInfo_templateObject3(), Theme/* mediaQuery.small */.cy.small((0,styled_components_browser_esm/* css */.iv)(CompanyReferenceInfo_templateObject2())));
var CompanyReferenceInfo = function(param) {
    var company = param.company;
    var references = company.references;
    var dictionary = (0,CompanyDictionary/* useCompanyDictionary */.F)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyReferenceInfo_Container, {
        children: references.map(function(item) {
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(References, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyReferenceInfo_LargeQuote, {
                        children: item.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: dictionary.referencesValue
                                    }),
                                    " ",
                                    item.value,
                                    " €"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                        children: [
                                            dictionary.referencesDate,
                                            " "
                                        ]
                                    }),
                                    " ",
                                    item.date
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                        children: [
                                            dictionary.referencesCustomer,
                                            " "
                                        ]
                                    }),
                                    " ",
                                    item.customer
                                ]
                            })
                        ]
                    })
                ]
            });
        })
    }));
};

;// CONCATENATED MODULE: ./components/company/CompanyPrivateFields.tsx











function CompanyPrivateFields_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function CompanyPrivateFields_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                CompanyPrivateFields_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                CompanyPrivateFields_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function CompanyPrivateFields_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CompanyPrivateFields_templateObject() {
    var data = CompanyPrivateFields_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n  padding: 2rem;\n  padding-top: 0;\n"
    ]);
    CompanyPrivateFields_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var CompanyPrivateFields = function(param) {
    var company = param.company;
    var user = (0,useUser/* useUser */.a)();
    var ref = (0,react.useState)(true), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(null), yearlyBuys = ref2[0], setYearlyBuys = ref2[1];
    var handleEdit = function() {
        var _ref = CompanyPrivateFields_asyncToGenerator(runtime_default().mark(function _callee() {
            var status;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.next = 3;
                        return (0,utils/* nextApiRequest */.Qd)('/api/v1/www/company/private-edit', {
                            companyID: company.companyID,
                            yearlyBuys: yearlyBuys || company.privateFields.yearlyBuys || null
                        });
                    case 3:
                        status = _ctx.sent.status;
                        if (status !== 'ok') console.error('Failed to save private fields', status);
                        setLoading(false);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleEdit() {
            return _ref.apply(this, arguments);
        };
    }();
    if (!user.isLoggedIn) return null;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyAccordion, {
        title: "Omat tiedot",
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* BasicInfoGrid */.KH, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyGrid/* Column */.sg, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyGrid/* Item */.ck, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    label: "Vuosiostot",
                                    variant: "outlined",
                                    type: "number",
                                    style: {
                                        width: 512
                                    },
                                    InputProps: {
                                        inputProps: {
                                            min: 0
                                        }
                                    },
                                    value: yearlyBuys || company.privateFields.yearlyBuys || '',
                                    onChange: function(event) {
                                        return setYearlyBuys(parseFloat(event.target.value));
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* Help */.W, {
                                    children: "T\xe4m\xe4 kentt\xe4 ja sen arvo n\xe4kyv\xe4t vain oman tilisi k\xe4ytt\xe4jille."
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Actions, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* Button */.z, {
                        loading: loading,
                        onClick: handleEdit,
                        children: "Tallenna"
                    })
                })
            ]
        }),
        onChange: function(_, state) {
            return setOpen(state);
        },
        expanded: open
    }));
};
var Actions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a4089a12-0"
})(CompanyPrivateFields_templateObject());

;// CONCATENATED MODULE: ./components/company/CompanyPage.tsx



































function CompanyPage_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function CompanyPage_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return CompanyPage_arrayLikeToArray(arr);
}
function CompanyPage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function CompanyPage_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                CompanyPage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                CompanyPage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function CompanyPage_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CompanyPage_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function CompanyPage_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function CompanyPage_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CompanyPage_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CompanyPage_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = CompanyPage_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function CompanyPage_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function CompanyPage_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CompanyPage_toConsumableArray(arr) {
    return CompanyPage_arrayWithoutHoles(arr) || CompanyPage_iterableToArray(arr) || CompanyPage_unsupportedIterableToArray(arr) || CompanyPage_nonIterableSpread();
}
function CompanyPage_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return CompanyPage_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return CompanyPage_arrayLikeToArray(o, minLen);
}
function CompanyPage_templateObject() {
    var data = CompanyPage_taggedTemplateLiteral([
        "\n  ",
        "\n  margin: 0 auto 6rem auto;\n  overflow: hidden;\n"
    ]);
    CompanyPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyPage_templateObject1() {
    var data = CompanyPage_taggedTemplateLiteral([
        "\n    flex-direction: column;\n\n    h2 {\n      font-size: 1.8rem;\n    }\n  "
    ]);
    CompanyPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompanyPage_templateObject2() {
    var data = CompanyPage_taggedTemplateLiteral([
        "\n  ",
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-top: 2rem;\n  padding: 2rem 0;\n\n  h2 {\n    font-size: 2.8rem;\n    margin-bottom: 0rem;\n  }\n\n  p {\n    display: flex;\n    align-items: center;\n    margin-top: 0.3rem;\n    margin-bottom: 0;\n    font-weight: normal;\n    font-size: 1rem;\n    color: ",
        ";\n  }\n\n  a {\n    color: ",
        ";\n  }\n\n  b {\n    margin-left: 0.3rem;\n    padding: 0.2rem 0.4rem;\n    background-color: ",
        ";\n    border-radius: ",
        "px;\n    color: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    CompanyPage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CompanyPage_templateObject3() {
    var data = CompanyPage_taggedTemplateLiteral([
        "\n    flex-direction: column;\n    align-items: center;\n    margin-left: 0;\n\n    > div {\n      margin-top: 1.5rem;\n      text-align: center;\n\n      p {\n        justify-content: center;\n      }\n    }\n  "
    ]);
    CompanyPage_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CompanyPage_templateObject4() {
    var data = CompanyPage_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  flex: 1;\n  margin-left: 2rem;\n\n  > div:first-child {\n    flex: 1;\n  }\n\n  ",
        "\n"
    ]);
    CompanyPage_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CompanyPage_templateObject5() {
    var data = CompanyPage_taggedTemplateLiteral([
        "\n    margin-top: 0.5rem;\n  "
    ]);
    CompanyPage_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function CompanyPage_templateObject6() {
    var data = CompanyPage_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    CompanyPage_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function CompanyPage_templateObject7() {
    var data = CompanyPage_taggedTemplateLiteral([
        "\n  ",
        "\n  margin-bottom: 1rem;\n  border-radius: ",
        "px;\n  overflow: hidden;\n"
    ]);
    CompanyPage_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
//
// Company page
// /[lang]/[hash]/[companyname]
//
var CompanyPage_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-babadc30-0"
})(CompanyPage_templateObject(), Theme/* cardStyles */.F);
var CompanyPage_Hero = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-babadc30-1"
})(CompanyPage_templateObject2(), Theme/* layoutStyles */.pG, (0,polished_esm/* lighten */.$n)(0.3, Theme/* Color.black */.Il.black), Theme/* Color.primary */.Il.primary, (0,polished_esm/* darken */._j)(0.1, Theme/* Color.background */.Il.background), Theme/* borderRadius */.E0, Theme/* Color.black */.Il.black, Theme/* mediaQuery.small */.cy.small((0,styled_components_browser_esm/* css */.iv)(CompanyPage_templateObject1())));
var HeroInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-babadc30-2"
})(CompanyPage_templateObject4(), Theme/* mediaQuery.small */.cy.small((0,styled_components_browser_esm/* css */.iv)(CompanyPage_templateObject3())));
var CompanyPage_Actions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-babadc30-3"
})(CompanyPage_templateObject6(), Theme/* mediaQuery.small */.cy.small((0,styled_components_browser_esm/* css */.iv)(CompanyPage_templateObject5())));
var Scaffold = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-babadc30-4"
})(CompanyPage_templateObject7(), Theme/* layoutStyles */.pG, Theme/* borderRadius */.E0);
var CompanyPage = function(_param) {
    var ssrCompany = _param.company, other = CompanyPage_objectWithoutProperties(_param, [
        "company"
    ]);
    var user = (0,useUser/* useUser */.a)();
    var dictionary = (0,CompanyDictionary/* useCompanyDictionary */.F)();
    var ref7 = (0,react.useState)(null), dynamicCompany = ref7[0], setDynamicCompany = ref7[1];
    var ref1 = (0,react.useState)(null), trustInfo = ref1[0], setTrustInfo = ref1[1];
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react.useState)(null), editDialogSection = ref3[0], setEditDialogSection = ref3[1];
    var ref4 = (0,react.useState)([
        'trustable',
        'operations',
        'certifications',
        'references',
        'contacts',
        'finance', 
    ]), openSections = ref4[0], setOpenSections = ref4[1];
    // Combine the original company data with the dynamically loaded one
    var company = CompanyPage_objectSpread({}, ssrCompany, dynamicCompany || {});
    var ref5 = (0,useCompanyActions/* useCompanyActionsInPage */.u)(company), isInCustomList = ref5.isInCustomList, renderThumbUpButton = ref5.renderThumbUpButton, renderThumbDownButton = ref5.renderThumbDownButton;
    var ref6 = (0,useCompanyActionMenu/* useCompanyActionMenuInPage */.B)(company), handleMenuOpen = ref6.handleMenuOpen, renderMenu = ref6.renderMenu;
    var userCompany = user.companies[0] || null;
    var premium = user.hasPremium || (userCompany === null || userCompany === void 0 ? void 0 : userCompany.businessID) == company.businessID || (dynamicCompany === null || dynamicCompany === void 0 ? void 0 : dynamicCompany.isPremium) || false; // Can see own company
    var userOwnCompany = (userCompany === null || userCompany === void 0 ? void 0 : userCompany.businessID) === company.businessID;
    var editable = userOwnCompany && user.accessRoleID === Constants/* AccountUserAccessRole.ADMIN */.Cn.ADMIN && (userCompany.isCompanyManualFormPending || !userCompany.isPending);
    var isPremiumOverride = !!(dynamicCompany === null || dynamicCompany === void 0 ? void 0 : dynamicCompany.premiumOverrideReason);
    var editSections = {
        image: CompanyImageEdit,
        basic: CompanyBasicInfoEdit,
        references: CompanyReferenceEdit,
        operations: CompanyOperationInfoEdit,
        contacts: CompanyContactInfoEdit
    };
    // Load dynamic data
    (0,react.useEffect)(function() {
        if (!ssrCompany) return;
        CompanyPage_asyncToGenerator(runtime_default().mark(function _callee() {
            var result, ref, status, tilaajavastuu;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,utils/* nextApiRequest */.Qd)('/api/v1/www/company/load', {
                            companyID: ssrCompany.companyID
                        }, {
                            delay: 2000
                        });
                    case 2:
                        result = _ctx.sent;
                        if (result.status == 'ok') {
                            setDynamicCompany(result.company);
                        } else {
                            console.log('Error loading company', result);
                        // TODO: Show error banner
                        }
                        if (false) {}
                        _ctx.next = 7;
                        return (0,utils/* nextApiRequest */.Qd)('/api/v1/company/tilaajavastuu', {
                            businessID: company.businessID
                        });
                    case 7:
                        ref = _ctx.sent;
                        status = ref.status;
                        tilaajavastuu = ref.tilaajavastuu;
                        if (status !== 'ok' || !tilaajavastuu) {
                            console.error('Failed to load tilaajavastuu', status, tilaajavastuu);
                        } else {
                            setTrustInfo(tilaajavastuu);
                        }
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }, [
        ssrCompany === null || ssrCompany === void 0 ? void 0 : ssrCompany.companyID
    ]);
    // Show loading state if expecting premium data
    (0,react.useEffect)(function() {
        var isExpectingMoreData = premium || editable;
        if (!isExpectingMoreData) return setLoading(false);
        setLoading(!dynamicCompany);
    }, [
        dynamicCompany,
        premium || editable
    ]);
    // Update company history
    (0,react.useEffect)(function() {
        (0,companyHistory/* recordCompanyVisit */.M)(company);
    }, [
        company.companyID
    ]);
    // Show paywall banner if scrolled too far
    (0,react.useEffect)(function() {
        if (premium) return;
        if (loading) return;
        // Show paywall after 10 secinds, even if not scrolling
        var timeout = setTimeout(function() {
            return (0,paywallStore/* openPaywall */.Oo)('company');
        }, 10000);
        var scrollListener = function() {
            if (window.scrollY > 800) (0,paywallStore/* openPaywall */.Oo)('company');
        };
        window.addEventListener('scroll', scrollListener, {
            passive: true
        });
        return function() {
            window.removeEventListener('scroll', scrollListener);
            clearTimeout(timeout);
        };
    }, [
        loading,
        premium,
        ssrCompany === null || ssrCompany === void 0 ? void 0 : ssrCompany.companyID
    ]);
    /** This is called from the company edit dialog when edits are saved */ var handleDocumentUpdate = function(document) {
        setDynamicCompany(document);
    };
    var handleSectionChange = function(id) {
        return function(event, expanded) {
            if (expanded) {
                setOpenSections(CompanyPage_toConsumableArray(openSections).concat([
                    id
                ]));
            } else {
                setOpenSections(openSections.filter(function(section) {
                    return section !== id;
                }));
            }
        };
    };
    var handleEditDialogOpen = function(section) {
        return function() {
            setEditDialogSection(section);
        };
    };
    var handleEditDialogClose = function() {
        setEditDialogSection(null);
    };
    var sectionProps = {
        company: company,
        editable: editable,
        premium: premium,
        loading: loading || user.isSSRRender
    };
    var premiumPreviewDescription = (dynamicCompany === null || dynamicCompany === void 0 ? void 0 : dynamicCompany.premiumOverrideReason) === 'recently-updated' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "company.premiumPreview.recentlyUpdatedDescription",
        defaultMessage: 'Koska t\xe4m\xe4 yritys on nostettu etusivun "Viimeksi p\xe4ivitetyt" listaukseen, n\xe4et kaikki sen tiedot ilmaiseksi. Jos haluat n\xe4hd\xe4 yritysten kaikki tiedot my\xf6s tulevaisuudessa, tilaa Constle -premium j\xe4senyys.'
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "company.premiumPreview.description",
        defaultMessage: 'T\xe4m\xe4 yritys on "demo" tilassa, joten n\xe4et kaikki sen tiedot ilmaiseksi. Jos haluat n\xe4hd\xe4 yritysten kaikki tiedot my\xf6s tulevaisuudessa, tilaa Constle -premium j\xe4senyys.'
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* CompanyPage */.o7, {
                company: company
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyPage_Hero, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyImage, CompanyPage_objectSpread({}, sectionProps, {
                        onEdit: handleEditDialogOpen('image')
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroInfo, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                                        children: company.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "Y-tunnus: ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                children: company.businessID
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyPage_Actions, {
                                children: [
                                    renderThumbUpButton(),
                                    renderThumbDownButton(),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
                                        "aria-label": "more options",
                                        component: "span",
                                        disabled: !user.isLoggedIn,
                                        onClick: handleMenuOpen,
                                        children: [
                                            isInCustomList ? /*#__PURE__*/ (0,jsx_runtime.jsx)((ClipboardTextIcon_default()), {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)((ClipboardTextOutlineIcon_default()), {}),
                                            isInCustomList && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyListRow/* IsInListIndicator */.gR, {})
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (dynamicCompany === null || dynamicCompany === void 0 ? void 0 : dynamicCompany.isPremium) && !user.hasPremium && !userOwnCompany && /*#__PURE__*/ (0,jsx_runtime.jsx)(Scaffold, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OmnibarPremiumBanner/* OmnibarPremiumBanner */.p, {
                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "company.premiumPreview.title",
                        defaultMessage: "Constle Pro -esikatselu"
                    }),
                    description: premiumPreviewDescription
                })
            }),
            (userCompany === null || userCompany === void 0 ? void 0 : userCompany.isUserManualFormPending) && !userCompany.isCompanyManualFormPending && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyPage_Hero, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner/* Banner */.j, {
                    type: "warning",
                    style: {
                        width: '100%'
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "company.companyUserPendingEdit.title",
                        defaultMessage: "HUOM! Rekister\xf6itymisesi on k\xe4sittelyss\xe4. Voit muokata yrityksen tietoja vasta, kun Constle on hyv\xe4ksynyt oikeutesi muokata yrityst\xe4."
                    })
                })
            }),
            userOwnCompany && editable && userCompany.isCompanyManualFormPending && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyPage_Hero, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner/* Banner */.j, {
                    type: "warning",
                    style: {
                        width: '100%'
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "company.companyPendingEdit.title",
                        defaultMessage: "HUOM! Yrityksesi liitt\xe4mispyynt\xf6 on k\xe4sittelyss\xe4. Voit muokata yrityksen tietoja, ja p\xe4ivit\xe4mme yrityssivun Constlen hakuun hyv\xe4ksymisen j\xe4lkeen."
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyPage_Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyBasicInfo, CompanyPage_objectSpread({}, sectionProps, {
                        editable: editable,
                        onEdit: handleEditDialogOpen('basic')
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyPrivateFields, {
                        company: company
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyAccordion, {
                        title: "Luotettava kumppani",
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyTrustInfo, CompanyPage_objectSpread({}, sectionProps, {
                            trustInfo: trustInfo,
                            isPremiumOverride: isPremiumOverride
                        })),
                        onChange: handleSectionChange('trustable'),
                        expanded: openSections.includes('trustable')
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyAccordion, {
                        title: "Toiminta",
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyOperationInfo, CompanyPage_objectSpread({}, sectionProps)),
                        onChange: handleSectionChange('operations'),
                        expanded: openSections.includes('operations'),
                        editable: editable,
                        onEdit: handleEditDialogOpen('operations')
                    }),
                    (editable || company.references.length > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyAccordion, {
                        title: dictionary.references,
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyReferenceInfo, CompanyPage_objectSpread({}, sectionProps)),
                        onChange: handleSectionChange('references'),
                        expanded: openSections.includes('references'),
                        editable: editable,
                        onEdit: handleEditDialogOpen('references')
                    }),
                    company.taitoCompetences.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyAccordion, {
                        title: "Sertifikaatit",
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyCertificateInfo, CompanyPage_objectSpread({}, sectionProps)),
                        onChange: handleSectionChange('certifications'),
                        expanded: openSections.includes('certifications')
                    }),
                    company.financials.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyAccordion, {
                        title: "Taloustiedot",
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFinanceInfo, CompanyPage_objectSpread({}, sectionProps)),
                        onChange: handleSectionChange('finance'),
                        expanded: openSections.includes('finance')
                    }),
                    (editable || company.locations.length > 0 || company.contactPersons.length > 0 || !premium) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyAccordion, {
                        title: "Yhteystiedot",
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyContactInfo, CompanyPage_objectSpread({}, sectionProps)),
                        onChange: handleSectionChange('contacts'),
                        expanded: openSections.includes('contacts'),
                        editable: editable,
                        onEdit: handleEditDialogOpen('contacts')
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyEditDialog, {
                open: !!editDialogSection,
                company: company,
                content: editSections[editDialogSection],
                onUpdate: handleDocumentUpdate,
                onClose: handleEditDialogClose
            }),
            renderMenu()
        ]
    }));
};


;// CONCATENATED MODULE: ./pages/company/[hash]/[slug].tsx






function _slug_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _slug_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _slug_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Company = function(_param) {
    var ssrCompany = _param.company, other = _slug_objectWithoutProperties(_param, [
        "company"
    ]);
    var isFallback = (0,router.useRouter)().isFallback;
    // Company page has not been generated at build time, waiting for Next.js to generate it now...
    if (isFallback) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(CompanySkeleton, {}));
    }
    // Company was not found, even after fallback retry
    if (!ssrCompany) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(error["default"], {
            statusCode: 404
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyPage, {
        company: ssrCompany
    }));
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (Company);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [929,868,9167,6571,5963,5997,1476,1453,9332,9774,2888,179], function() { return __webpack_exec__(13561); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);